import React, {Component} from 'react'
import styled from 'styled-components'
import fire from '../../../../database/firebase'
import Typewriter from 'typewriter-effect';
import ClipLoader from "react-spinners/ClipLoader";
import SignUpCustomer from '../../SignUpPage/Customer-Side/SignUpCustomer';
import SignUpBusiness from '../../SignUpPage/Business-Side/SignUpBusiness';
import { CSSTransition } from 'react-transition-group';
import MediaQuery from 'react-responsive';

const Container = styled.div`
    width: 100%;
    background-color: #fff;
    //   padding: 1%;
    position: relative; /* Position relative to contain the dropdown */
    text-align: right;
    border-bottom: 0.5px solid white;
    padding-bottom: 2%;
    margin-bottom: 2%;
    z-index: 2;
`;

const Button = styled.button`
    background-color: #fff;
    color: #fff;
    padding-left: 4%;
    padding-right: 4%;
    cursor: pointer;
    padding-top: 0px;
    padding-bottom: 0px;
    margin-right: 3.5%;
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #0930cb;
    margin-top: 4%;
    z-index: 2;
`;

const Dropdown = styled.div`
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.35);
    position: absolute;
    top: 100%; /* Position the dropdown below the button */
    left: 0;
    width: 96%; /* Expand the dropdown to the full width of the container */
    display: ${props => (props.open ? 'block' : 'none')}; /* Show/hide the dropdown */
    background-color: #fff;
    color: #0930cb;
    padding: 10px;
    //   border: 0.7px solid white;
    // border-top: 1px solid #fff;
    // border-bottom: 1px solid #fff;
    font-family: sora;
    // border-bottom-left-radius: 1.5%;
    // border-bottom-right-radius: 1.5%;
    transition: max-height 0.3s ease-in, opacity 0.3s ease-in; /* Add transitions */
    max-height: ${props => (props.open ? '200px' : '0')}; /* Set max-height for smooth expansion and collapse */
    overflow: hidden; /* Hide overflow content */
    opacity: ${props => (props.open ? '1' : '0')}; /* Set opacity for fade-in and fade-out */
`;

const Styles = styled.div `

    // - - NAVBAR - - //

.navBar:after {
    content: "";
    display: table;
    clear: both;
}

.logo {
    text-align: left;
    width: 60%;
    float: left;
}

.user {
    text-align: right;
    width: 20%;
    float: left;
}

    // - LOGO - //

.logo h3 {
    margin-left: 3.5%;
    font-size: 25px;
    z-index: 2;
}


    // - USER - //

.user button {
    // height: 50%;
    margin-right: 5%;
    width: 85%;
    padding: 5%;
    border-radius: 8px;
    border: 2px solid #321d05;
    font-family: Arvo;
    background-color: #fff;
    color: #321d05;
    font-weight: bold;
    font-size: 100%;
    cursor: pointer;
}

.user button:hover {
    background-color: #321d05;
    color: white;
}

.user h4 {
    margin-top: 4.5%;
}

    // - - PAGE HEADER - - //

.pageHeader {

}

.pageHeader h1 {
    text-align: left;
    margin-top: 0px;
    margin-left: 2%;
    font-size: 60px;
    width: 95%;
}

.pageHeader span {
    font-size: 65px;
    color: #321d05;
}

    // - - PAGE BODY - - //

.pageBody {
    max-width: 100%;
    width: 100%;
    overflow-x: none;
}

.pageBody:after {
    content: "";
    display: table;
    clear: both;
}

.pageBodyLeft {
    text-align: left;
    width: 75%;
    float: left;
}

.pageBodyRight {
    text-align: left;
    width: 24.5%;
    float: left;
}

    // - - PAGE PICTURE LEFT - - //

.pageBodyLeft img {
    width: 100%;
}

.pageBodyLeft video {
    width: 100%;
}

    // - - PAGE PICTURE RIGHT - - //

.pageBodyRight {
    text-align: center;
}

.pageBodyRight img {
    margin-top: 13.5%;
    max-width: 92%;
    width: 110%;
    margin-right: 10%;
}

.pageBodyRight video {
    margin-top: 13.5%;
    max-width: 92%;
    width: 110%;
    margin-right: 10%;
}

.pageBodyRight button {
    margin-top: 2.5%;
}

    // - - REQUEST DEMO BUTTON - - //

.requestDemoBtn button {
    margin-top: 8.5%;
    padding: 5%;
    width: 50%;
    background-color: #321d05;
    border-radius: 30px;
    color: white;
    font-family: sora;
    border: 2px solid #321d05;
    font-size: 95%;
    cursor: pointer;
}

.requestDemoBtn button:hover {
    background-color: #ff914d;
    border: 2px solid #ff914d;
}

    // - - ESSENTIAL READINGS - - //

.essentialReadings:after {
    content: "";
    display: table;
    clear: both;
}

.reading {
    margin-top: 3%;
    margin-bottom: 3%;
    float: left;
    text-align: center;
    width: 33.3%;
}

.readingCard {
    position: relative;
    margin: auto;
    width: 60%;
    height: 40vh;
    border: 2px solid #321d05;
    border-radius: 8px;
}

.readingCard img {
    width: 80%;
    margin-top: 5%;
}

.readingCard h3 {
    position: absolute;
    left: 5%;
    margin-right: 5%;
    bottom: 32.5%;
    font-family: sora;
    margin-top: 0px;
}

.readingCard p {
    position: absolute;
    text-align: center;
    // margin-right: 5%;
    right: 5%;
    bottom: 14%;
    font-family: sora;
    color: #0930cb;
    font-weight: bold;
    font-size: 90%;
}

.readingCard button {
    position: absolute;
    right: 5%;
    bottom: 5%;
    width: 40%;
    padding: 2.5%;
    background-color: #321d05;
    color: white;
    font-family: sora;
    font-size: 90%;
    border: 2px solid #321d05;
    border-radius: 8px;
    cursor: pointer;
}

.readingCard2 {
    position: relative;
    margin: auto;
    width: 60%;
    height: 40vh;
    border: 2px solid #321d05;
    border-radius: 8px;
}

.readingCard2 img {
    width: 80%;
    margin-top: 5%;
}

.readingCard2 h3 {
    position: absolute;
    left: 5%;
    margin-right: 5%;
    bottom: 26%;
    font-family: sora;
    margin-top: 0px;
}

.readingCard2 p {
    position: absolute;
    text-align: center;
    // margin-right: 5%;
    right: 5%;
    bottom: 14%;
    font-family: sora;
    color: #0930cb;
    font-weight: bold;
    font-size: 90%;
}

.readingCard2 button {
    position: absolute;
    right: 5%;
    bottom: 5%;
    width: 40%;
    padding: 2.5%;
    background-color: #321d05;
    color: white;
    font-family: sora;
    font-size: 90%;
    border: 2px solid #321d05;
    border-radius: 8px;
    cursor: pointer;
}

.usefulQuotes {
    position: relative;
    width: 100%;
    height: 96vh; /* Adjust height as needed */
    background-image: url('/assets/customer3Background7.png'); 
    background-size: cover;
    background-position: center;
}

.quoteOverlay:after {
    content: "";
    display: table;
    clear: both;
}

.quoteCol {
    float: left;
    text-align: center;
    width: 31.5%;
}

.quoteCol p {
    margin-top: 0px;
}

.quoteCol p:hover {
    
}

.quoteCol a {
    text-decoration: none;
    color: black;
    font-family: sora;
    font-weight: bold;
}

.quoteCol a:hover {
    color: #0930cb;
    text-decoration: underline;
}

    // - - FEATURES - - //

.featuresContainer:after {
    content: "";
    display: table;
    clear: both;
}

.featuresCol1 {
    text-align: center;
    width: 50%;
    float: left;
}

.featuresCol2 {
    text-align: center;
    width: 50%;
    float: left;
}

    // - FEATURES COL 1 - //

.featuresCol1 h1 {
    text-align: left; 
    margin-left: 3.5%;
    color: white; 
    font-family: sarabun;
    font-size: 38px;
}

.featuresCol1 img {
    width: 90%;
}

    // - FEATURES COL 2 - //

.featuresCol2 h1 {
    text-align: left; 
    margin-left: 3.5%;
    color: white; 
    font-family: sarabun;
    font-size: 38px;
}

.featuresCol2 img {
    width: 90%;
}

.lastFeatureCol video {
    width: 100%;
}

.lastFeatureCol button {
    width: 20%;
    padding: 1.75%;
    font-size: 25px;
    border-radius: 50px; 
    border: 2px solid transparent;
    font-family: sora;
}

.lastFeatureCol button:hover {
    background-color: #ff914D;
    color: white;
    cursor: pointer;
    font-weight: bold;
}

    // - - PRICING - - //

.priceCard {
    margin: auto;
    width: 27.5%;
    height: auto;
    border: 2px solid #321d05;
    border-radius: 10px;
}

.priceCard h2 {
    text-align: left;
    margin-left: 3%;
    font-family: sora;
    color: #321d05;
    font-weight: bold;
    margin-top: 7.5%;
}

.priceCard h1 {
    text-align: left;
    font-family: rubik;
    font-weight: bolder;
    font-size: 52px;
    margin-left: 3%;
    color: #321d05;
    margin-bottom: 0px;
}

.priceCard p {
    margin-top: 1%;
    font-weight: bold;
    color: #000;
    font-family: sora;
}

.priceCard button {
    width: 90%;
    padding: 3.5%;
    background-color: #321d05;
    border-radius: 8px;
    border: 2px solid #321d05;
    color: white;
    font-family: sora;
    font-size: 95%;
    cursor: pointer;
    margin-bottom: 5%;
}

    // - - PRICE TIME FRAME OPTIONS - - //

.priceTimeFrame {
    margin-top: 2%;
    margin-bottom: 2.5%;
}

.priceTimeFrame button {
    padding: 0.75%;
    width: 10%;
    font-weight: bold;
    font-family: sora;
    cursor: pointer;
}

    // - - PRICE FEATURES - - //

.priceFeatures {
    margin-left: 3%;
    margin-bottom: 1%;
}

.priceFeatures:after {
    content: "";
    display: table;
    clear: both;
}

.priceFeatureCol1 {
    text-align: right;
    float: left;
    width: 10%;
}

.priceFeatureCol2 {
    text-align: left;
    float: left;
    width: 90%;
}

    // - PRICE FEATURE COL 1 - //

.priceFeatureCol1 img {
    width: 80%;
}

    // - PRICE FEATURE COL 2 - //


.priceFeatureCol2 p {
    margin-top: 2%;
    margin-left: 1.5%;
    font-size: 90%;
}

    /* CSS Transition Definitions */
.dialog-slide-enter {
    transform: translateY(30%);
    opacity: 0;
}

.dialog-slide-enter-active {
    transform: translateY(0);
    opacity: 1;
    transition: transform 500ms, opacity 500ms;
}

.dialog-slide-exit {
    transform: translateY(0);
    opacity: 1;
}

.dialog-slide-exit-active {
    transform: translateY(100%);
    opacity: 0;
    transition: transform 500ms, opacity 500ms;
}

    /* CSS Transition Definitions */
.dialog-slide2-enter {
    transform: translateY(-5%);
    opacity: 0;
}

.dialog-slide2-enter-active {
    transform: translateY(0);
    opacity: 1;
    transition: transform 500ms, opacity 500ms;
}

.dialog-slide2-exit {
    transform: translateY(0);
    opacity: 1;
}

.dialog-slide2-exit-active {
    transform: translateY(100%);
    opacity: 0;
    transition: transform 500ms, opacity 500ms;
}

    // - - PAGE FOOTER - - //

.footer {
    margin-top: 4%;
    padding-top: 4%;
    padding-left: 10%;
    padding-right: 10%;
    padding-bottom: 2%;
    background-color: #321d05;
}

.footer:after {
    content: "";
    display: table;
    clear: both;
}

.footerCol1 {
    text-align: left;
    width: 22.5%;
    float: left;
}

.footerCol2 {
    text-align: left;
    width: 22.5%;
    float: left;
}

.footerCol3 {
    text-align: left;
    width: 22.5%;
    float: left;
}

.footerCol4 {
    text-align: left;
    width: 20%;
    float: left;
}

    // - FOOTER COL 1 - - //

.footerCol1 img {
    width: 12.5%;
}

.footerCol1 p {
    margin-left: 2%;
    margin-top: 0.5%;
    margin-bottom: 3.5%;
    font-family: Arvo;
    color: white;
}

.footerSocial {
    // text-align: right;
}

.footerSocial img {
    // margin-left: 5%; 
    margin-top: 14%;
    width: 6%;
    cursor: pointer;
}

    // - FOOTER COL 2 - //

.footerCol2 h3 {
    color: white;
    font-family: rubik;
    margin-top: 0px;
}

.footerCol2 p {
    color: white;
    font-family: rubik;
}

.footerCol2 label:hover {
    text-decoration: underline;
    cursor: pointer;
}

    // - FOOTER COL 3 - //

.footerCol3 h3 {
    color: white;
    font-family: rubik;
    margin-top: 0px;
}

.footerCol3 p {
    color: white;
    font-family: rubik;
}

.footerCol3 label:hover {
    text-decoration: underline;
    cursor: pointer;
}

    // - FOOTER COL 4 - //

.footerCol4 h3 {
    color: white;
    font-family: rubik;
    margin-top: 0px;
}

.footerCol4 p {
    color: white;
    font-family: rubik;
}

.footerCol4 label:hover {
    text-decoration: underline;
    cursor: pointer;
}

    // - - LOADING SCREEN - - //

.loadingScreen {
    padding-top: 23.5%;
    padding-bottom: 4%;
    text-align: center;
}

    // - - - - - SMALL PHONE - - - - - - //

    // - - NAVBAR - - //

.menu-btn {
    width: 25px;
    height: 25px;
}

.dropdown {
    z-index: 1;
}

.dropdown p:hover {
    text-decoration: underline;
}

    // - - SMALL PHONE HEADER - - //

.smallPhoneVideo {
    text-align: center;
    height: auto;
}

.smallPhoneVideo video {
    margin: auto;
    width: 80%;
}

    // - - SMALL PHONE DASHBOARD - - //

.smallPhoneVideoDashboard {
    text-align: center;
    height: auto;
}

.smallPhoneVideoDashboard video {
    border-radius: 8px;
    border: 2px solid #0930cb;
    margin: auto;
    width: 90%;
}

.smallPhoneImg img {
    margin-top: 5%;
    width: 7.5%;
}

    // - - SMALL PHONE FEATURES BTN - - //

.smallPhoneFeaturesBtn {
    margin-top: 10%;
    margin-bottom: 7.5%;
}

.smallPhoneFeaturesBtn button {
    padding: 5%;
    border-radius: 30px;
    // width: 40%;
    background-color: white;
    color: #321d05;
    font-size: 90%;
    font-family: sora;
    border: 2px solid #321d05;
}

    // - - PRICING - - //

.priceCardSmallPhone {
    margin: auto;
    width: 90.5%;
    height: auto;
    border: 2px solid #321d05;
    border-radius: 10px;
}

.priceCardSmallPhone h2 {
    text-align: left;
    margin-left: 3%;
    font-family: sora;
    color: #321d05;
    font-weight: bold;
    margin-top: 7.5%;
}

.priceCardSmallPhone h1 {
    text-align: left;
    font-family: rubik;
    font-weight: bolder;
    font-size: 35px;
    margin-left: 3%;
    color: #321d05;
    margin-bottom: 0px;
}

.priceCardSmallPhone p {
    margin-top: 1%;
    font-weight: bold;
    color: #000;
    font-family: sora;
}

.priceCardSmallPhone button {
    width: 90%;
    padding: 3.5%;
    background-color: #321d05;
    border-radius: 8px;
    border: 2px solid #321d05;
    color: white;
    font-family: sora;
    font-size: 95%;
    cursor: pointer;
    margin-bottom: 5%;
}


    // - - PRICE TIME FRAME OPTIONS - - //

.priceTimeFrameSmallPhone {
    margin-top: 2%;
    margin-bottom: 7.5%;
}

.priceTimeFrameSmallPhone button {
    padding: 4.75%;
    width: 35%;
    font-weight: bold;
    font-family: sora;
    cursor: pointer;
}

    // - - FOOTER  - - //

.footerSmallPhone {
    padding-top: 7.5%;
    background-color: #321d05;
    padding-bottom: 6.e5%;
}

.footerCol1SmallPhone {
    width: 100%;
}

.footerCol1SmallPhone {
    width: 100%;
}

.footerCol3SmallPhone {
    margin-top: 8%;
    width: 100%;
    padding-bottom: 7.5%;
}

    // - FOOTER COL 1 - //

.footerCol1SmallPhone img {
    width: 7.5%;
    margin-left: 5%;
}

    // - FOOTER COL 2 - //

.footerCol2SmallPhone h3 {
    margin-left: 5%;
    color: white;
    font-family: rubik;
}

.footerCol2SmallPhone p {
    margin-left: 5%;
    color: white;
    font-family: rubik;
}

.footerCol2SmallPhone label:hover {
    text-decoration: underline;
}

    // - FOOTER COL 3 - //


.footerCol3SmallPhone h3 {
    margin-left: 5%;
    color: white;
    font-family: rubik;
}

.footerCol3SmallPhone p {
    margin-left: 5%;
    color: white;
    font-family: rubik;
}

.footerCol3SmallPhone label:hover {
    text-decoration: underline;
}

.footerCol3SmallPhone a {
    color: white;
    text-decoration: none;
}


    // - - - - - PHABLET PHONE - - - - - - //



`

export default class SignUp extends Component {
    constructor() {
        super()
        this.state = {
            showLandingPage: true,
            showMonthlyPriceCard: true,
            showYearlyPriceCard: false,
            monthlyBgColor: "#0930cb",
            monthlyTxtColor: "white",
            yearlyBgColor: "white",
            yearlyTxtColor: "#0930cb"
        }
    }
    
    componentDidMount = () => {

    }

        //* - - COMPUTER VIEWS - - *//

    renderDesktopView = () => {
        let loginBtnStyle = {
            backgroundColor: "white",
            border: "2px solid #0930cb",
            color: "#0930cb"
        }
        return (
            <div>
                {this.state.showLandingPage && 
                    <div style={{maxWidth: "100%", overflowX: "none"}}>
                        <div style={{display: "flex", justifyContent: "space-between"}} className='navBar'>
                            <div className='logo'>
                                <h3>kifaa</h3>
                            </div>
                            <div className='user'>
                                <h4><button
                                // style={loginBtnStyle}
                                onClick={this.handleScrollToFeatures}
                                >Features</button></h4>
                            </div>
                            <div className='user'>
                                <h4><button
                                // style={loginBtnStyle}
                                onClick={this.handleScrollToPricing}
                                >Pricing</button></h4>
                            </div>
                        </div>
                        <div className='pageBody'>
                            <div className='pageBodyLeft'>
                                <div className='pageHeader'>
                                    <h1>
                                        <span><u><Typewriter options={{
                                        strings: ["elevate your brand with", 'worthwhile', "personalised", "easy to setup"],
                                        autoStart: true,
                                        loop: true,
                                        }}
                                        /></u></span> rewards for your <label>best</label> customers
                                    </h1>
                                </div>
                                <div className='pagePicture'>
                                    <img src='/assets/customerBackground35.png'/>
                                </div>
                            </div>
                            <div className='pageBodyRight'>
                            <video
                                autoPlay
                                loop
                                muted
                                playsInline
                                className='pageVideo'
                            >
                                <source src='/assets/customerBackgroundRight3.5.mp4' type='video/mp4' />
                                {/* You can add additional source elements for different video formats */}
                                Your browser does not support the video tag.
                            </video>
                                <div className='requestDemoBtn'>
                                    <button
                                    onClick={this.bookCalendarEvent}
                                    >Schedule Demo</button>
                                </div>
                            </div>
                        </div>
                        <div className='pageBody'>
                            <div style={{width: "25%", textAlign: "right"}} className='pageBodyRight'>
                                <img src='/assets/part2.55HomeSection56.png'/>
                            </div>
                            <div style={{textAlign: "center"}} className='pageBodyLeft'>
                                <img src='/assets/part2HomeSection2.97.png'/>
                            </div>
                        </div>
                        <div className='pageBody' style={{width: "100%", height: "auto"}}>
                            <h1 style=
                            {{
                                marginTop: "1.5%",
                                color: "#321d05", 
                                textAlign: "center", 
                                fontSize: "75px", 
                                fontFamily: "sora",
                                paddingTop: "1%",
                                marginBottom: "0px",
                            }}>Essential Reading</h1>
                            <h2 style={{textAlign: "center", fontFamily: "sora"}}>Before you consider buying, I highly recommend you read the following:</h2>
                            <div className='essentialReadings'>
                                <div className='reading'>
                                    <div style={{width: "67.5%"}} className='readingCard'>
                                        <img src='/assets/hbr-logo.png'/>
                                        <h3 style={{color: "#0930cb"}}>Title: <label style={{color: "#321d05"}}>Do Rewards Really Create Loyalty?</label></h3>
                                        <p>(20 mins)</p>
                                        <button onClick={this.goToArticle1}><a style={{textDecoration: "none", color: "white"}} target='_blank' href='https://hbr.org/1995/05/do-rewards-really-create-loyalty'>Read</a></button>
                                    </div>
                                </div>
                                <div className='reading'>
                                    <div style={{width: "67.5%"}} className='readingCard'>
                                        <img style={{marginTop: "10%"}} src='/assets/sloan-logo.png'/>
                                        <h3 style={{color: "#0930cb"}}>Title: <label style={{color: "#321d05"}}>Do Customer Loyalty Programs Really Work?</label></h3>
                                        <p>(35 mins)</p>
                                        <button onClick={this.goToArticle2}><a style={{textDecoration: "none", color: "white"}} target='_blank' href='https://www.researchgate.net/publication/290890144_Do_Customer_Loyalty_Programs_Really_Work'>Read</a></button>
                                    </div>
                                </div>
                                <div className='reading'>
                                    <div style={{width: "67.5%"}} className='readingCard2'>
                                        <img style={{marginTop: "0%", width: "95%"}} src='/assets/hubspot-logo.jpeg'/>
                                        <h3 style={{color: "#0930cb"}}>Title: <label style={{color: "#321d05"}}>The Beginner's Guide to Building a Customer Loyalty Program</label></h3>
                                        <p>(20 mins)</p>
                                        <button onClick={this.goToArticle3}><a style={{textDecoration: "none", color: "white"}} target='_blank' href='https://blog.hubspot.com/service/customer-loyalty-program'>Read</a></button>
                                    </div>
                                </div>
                            </div>
                            <div style={{width: "100%"}} className='usefulQuotes'>
                                <div className="quoteOverlay">
                                    <div className='quoteCol'>
                                        <h2 style={{
                                            marginTop: "62.5%", 
                                            paddingLeft: "0%", 
                                            paddingRight: "1.5%",
                                            fontFamily: "sora",
                                            color: "#321d05",
                                            marginBottom: "3%",
                                            // fontSize: "15px"
                                            // fontSize: "100%"
                                        }}>Starbucks Rewards members accounted for 55% of sales at US company-operated stores...</h2>
                                        <p><a target='_blank' href='https://africa.businessinsider.com/retail/customers-might-hate-starbucks-new-reward-program-but-wall-street-loves-it/4qmd6x6'> - Business Insider</a></p>
                                    </div>
                                    <div style={{
                                        marginTop: "26.5%", 
                                        paddingLeft: "0%", 
                                        paddingRight: "2.5%",
                                        fontFamily: "sora",
                                        color: "#321d05",
                                        marginBottom: "2%",
                                        fontSize: "14px"
                                    }} className='quoteCol'>
                                        <h2>It's more cost-effective for your business to retain happy customers than acquire new ones. Acquiring a new customer is 5-25X more expensive than retaining a current one.</h2>
                                        <p><a target='_blank' href='https://blog.hubspot.com/service/customer-loyalty-program'> - HubSpot</a></p>
                                    </div>
                                    <div style={{
                                        marginTop: "22.25%", 
                                        paddingLeft: "0%", 
                                        paddingRight: "1.5%",
                                        fontFamily: "sora",
                                        color: "#321d05",
                                        marginBottom: "2%",
                                        fontSize: "14px"
                                    }} className='quoteCol'>
                                        <h2>A study by McKinsey, for example, found that customers who are members of a [paid] loyalty program are 59% more likely to choose a brand over a competitor and 43% more likely to buy weekly.</h2>
                                        <p><a target='_blank' href='https://www.forbes.com/sites/forbestechcouncil/2022/11/18/loyalty-programs-what-works-and-what-doesnt/?sh=4c634a486539'> - Forbes</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id='features' style={{width: "100%", height: "auto", backgroundColor: "#0930cb", marginTop: "3%"}} className='pageBody'>
                            <h1 style=
                            {{
                                color: "white", 
                                textAlign: "center", 
                                fontSize: "75px", 
                                fontFamily: "sora",
                                paddingTop: "2.5%",
                                marginBottom: "0px"
                            }}>Features</h1>
                            <div className='featuresContainer'>
                                <div className='featuresCol1'>
                                    <h1 style={{paddingTop: "2%"}}>
                                        Make quick & easy modifications to your customer-facing web application as needed
                                    </h1>
                                    <h1 style={{paddingTop: "3%", marginBottom: "0px"}}>
                                        Add customization to suit the language and look of your brand 
                                    </h1>
                                </div>
                                <div className='featuresCol2'>
                                    <img src='/assets/featuresRightCol2.png'/>
                                </div>
                            </div>
                            <div style={{width: "100%", textAlign: "center"}} className='pageBodyLeft'>
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    className='pageVideo'
                                >
                                    <source src='/assets/part3HomeSection5.mp4' type='video/mp4' />
                                    {/* You can add additional source elements for different video formats */}
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                            <div style={{textAlign: "center"}} className='pageBodyRight'>
                                {/* <img src='/assets/part2HomeSection2.57.png'/> */}
                            </div>
                        </div>
                        <div style={{width: "100%", height: "auto", backgroundColor: "#0930cb", marginTop: "0px"}} className='pageBody'>
                            {/* <h1 style=
                            {{
                                color: "white", 
                                textAlign: "center", 
                                fontSize: "75px", 
                                fontFamily: "sora",
                                paddingTop: "2.5%",
                                marginBottom: "0px"
                            }}>Features</h1> */}
                            <div className='featuresContainer'>
                                <div className='featuresCol1'>
                                    <img src='/assets/featuresRightCol3.5.png'/>
                                </div>
                                <div className='featuresCol2'>
                                    <h1 style={{paddingTop: "1%", marginRight: "3.5%", marginTop: "1.5%"}}>
                                        Create incentives for customers to spend by offering higher value earning on various purchases
                                    </h1>
                                    <h1 style={{paddingTop: "6%", marginRight: "3.5%"}}>
                                        Create on-menu OR off-menu rewards for your customers in seconds
                                    </h1>
                                </div>
                            </div>
                            <div style={{width: "100%", textAlign: "center"}} className='pageBodyLeft'>
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    className='pageVideo'
                                >
                                    <source src='/assets/part4HomeSection35.mp4' type='video/mp4' />
                                    {/* You can add additional source elements for different video formats */}
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                            <div style={{textAlign: "center"}} className='pageBodyRight'>
                                {/* <img src='/assets/part2HomeSection2.57.png'/> */}
                            </div>
                            <div className='featuresContainer'>
                                <div className='featuresCol1'>
                                    <img src='/assets/featuresRightCol5.6.png'/>
                                </div>
                                <div className='featuresCol2'>
                                    <h1 style={{paddingTop: "1%", marginRight: "3.5%", marginTop: "1.5%"}}>
                                        Segment your customers for better targeted email marketing
                                    </h1>
                                    <h1 style={{paddingTop: "6%", marginRight: "3.5%"}}>
                                        Track analytics for meals, rewards and customer spending all-year round
                                    </h1>
                                </div>
                            </div>
                            <div  className='lastFeatureCol' style={{textAlign: "center", marginBottom: "5%"}}>
                                <button
                                onClick={this.bookCalendarEvent}
                                style={{marginTop: "2%"}}
                                >Schedule a demo</button>
                            </div>
                        </div>
                        <div id='pricing' style={{textAlign: "center"}}>
                            <h1 style=
                            {{
                                color: "#321d05", 
                                textAlign: "center", 
                                fontSize: "75px", 
                                fontFamily: "sora",
                                marginBottom: "1%"
                            }}>Pricing</h1>
                            <div className='priceTimeFrame'>
                                <button
                                onClick={this.monthlyPriceCardClicked}
                                style={{
                                    backgroundColor: this.state.monthlyBgColor,
                                    color: this.state.monthlyTxtColor,
                                    borderTopLeftRadius: "8px",
                                    borderBottomLeftRadius: "8px",
                                    border: "1px solid #0930cb",
                                    borderRight: "0px solid transparent"
                                }}
                                >Monthly</button>
                                <button
                                onClick={this.yearlyPriceCardClicked}
                                style={{
                                    backgroundColor: this.state.yearlyBgColor,
                                    color: this.state.yearlyTxtColor,
                                    borderTopRightRadius: "8px",
                                    borderBottomRightRadius: "8px",
                                    border: "1px solid #0930cb"
                                }}
                                >Yearly</button>
                            </div>
                            <CSSTransition
                            in={this.state.showMonthlyPriceCard}
                            timeout={500}
                            classNames="dialog-slide"
                            unmountOnExit
                            >
                                <div>
                                    {this.state.showMonthlyPriceCard && 
                                        <div className='priceCard'>
                                            <h2>Standard</h2>
                                            <h1>15,000 Kshs<label style={{fontSize: "14px", marginLeft: "1%"}}>/ month</label></h1>
                                            <p>(per branch)</p>
                                            <div style={{marginTop: "8%"}}>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Unlimited customer sign ups</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Unlimited customer rewards</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Unlimited feature access</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>White label branding</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Personalized URL for your brand</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{marginTop: "6.5%"}}>
                                                <button
                                                onClick={this.bookCalendarEvent}
                                                >Get Started</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </CSSTransition>
                            <CSSTransition
                            in={this.state.showYearlyPriceCard}
                            timeout={500}
                            classNames="dialog-slide"
                            unmountOnExit
                            >
                                <div>
                                    {this.state.showYearlyPriceCard && 
                                        <div className='priceCard'>
                                            <h2>Standard <label style={{fontSize: "17.5px", color: "red", fontFamily: "rubik", marginLeft: "2%"}}>(Save 33% annually)</label></h2>
                                            <h1>10,000 Kshs<label style={{fontSize: "14px", marginLeft: "1%"}}>/ month</label></h1>
                                            <p>(per branch)</p>
                                            <div style={{marginTop: "8%"}}>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Unlimited customer sign ups</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Unlimited customer rewards</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Unlimited feature access</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>White label branding</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Personalized URL for your brand</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{marginTop: "6.5%"}}>
                                                <button
                                                >Get Started</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </CSSTransition>
                        </div>
                        <div className='footer'>
                            <div className='footerCol1'>
                                <img src="/assets/paper-plane-logo.png"/>
                                <div className='footerSocial'>
                                    {/* <img src='/assets/footer-linkedin.png'/> */}
                                </div>
                                {/* <label style={{marginLeft: "1.5%", color: "white", fontFamily: "sora"}}>kifaa</label> */}
                                {/* <p>© kifaa</p> */}
                            </div>
                            <div className='footerCol2'>
                                <h3>Product</h3>
                                <p onClick={this.handleScrollToFeatures}><label>Features</label></p>
                                <p onClick={this.handleScrollToPricing}><label>Pricing</label></p>
                            </div>
                            <div className='footerCol3'>
                                <h3>Contact</h3>  
                                <p><label>+254717230621</label></p> 
                            </div>
                            <div className='footerCol4'>
                                {/* <h3>Legal</h3>  
                                <p><label>Terms of use</label></p> 
                                <p><label>Privacy policy</label></p>  */}
                            </div>
                        </div>
                    </div>
                }
                {this.state.showLoadingScreen && 
                    <div className='loadingScreen'>
                        <ClipLoader
                        color="#0930CB"
                        loading={true}
                        // cssOverride={override}
                        size={60}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                        />
                    </div>
                }
                {this.state.showSignUpBusinessPage &&
                    <div className=''>
                        <SignUpBusiness/>
                    </div>
                }
            </div>
        )
    }

    renderLargerDesktopView = () => {
        let loginBtnStyle = {
            backgroundColor: "white",
            border: "2px solid #0930cb",
            color: "#0930cb"
        }
        return (
            <div>
                {this.state.showLandingPage && 
                    <div style={{maxWidth: "100%", overflowX: "none"}}>
                        <div style={{display: "flex", justifyContent: "space-between"}} className='navBar'>
                            <div className='logo'>
                                <h3>kifaa</h3>
                            </div>
                            <div className='user'>
                                <h4><button
                                // style={loginBtnStyle}
                                onClick={this.handleScrollToFeatures}
                                >Features</button></h4>
                            </div>
                            <div className='user'>
                                <h4><button
                                // style={loginBtnStyle}
                                onClick={this.handleScrollToPricing}
                                >Pricing</button></h4>
                            </div>
                        </div>
                        <div className='pageBody'>
                            <div className='pageBodyLeft'>
                                <div className='pageHeader'>
                                    <h1 style={{fontSize: "55px"}}>
                                        <span><u><Typewriter options={{
                                        strings: ["elevate your brand with", 'worthwhile', "personalised", "easy to setup"],
                                        autoStart: true,
                                        loop: true,
                                        }}
                                        /></u></span> rewards for your <label>best</label> customers
                                    </h1>
                                </div>
                                <div className='pagePicture'>
                                    <img src='/assets/customerBackground35.png'/>
                                </div>
                            </div>
                            <div className='pageBodyRight'>
                            <video
                                autoPlay
                                loop
                                muted
                                playsInline
                                className='pageVideo'
                            >
                                <source src='/assets/customerBackgroundRight3.5.mp4' type='video/mp4' />
                                {/* You can add additional source elements for different video formats */}
                                Your browser does not support the video tag.
                            </video>
                                <div className='requestDemoBtn'>
                                    <button
                                    style={{width: "70%"}}
                                    onClick={this.bookCalendarEvent}
                                    >Schedule Demo</button>
                                </div>
                            </div>
                        </div>
                        <div className='pageBody'>
                            <div style={{width: "25%", textAlign: "right"}} className='pageBodyRight'>
                                <img src='/assets/part2.55HomeSection56.png'/>
                            </div>
                            <div style={{textAlign: "center"}} className='pageBodyLeft'>
                                <img src='/assets/part2HomeSection2.97.png'/>
                            </div>
                        </div>
                        <div className='pageBody' style={{width: "100%", height: "auto"}}>
                            <h1 style=
                            {{
                                marginTop: "1.5%",
                                color: "#321d05", 
                                textAlign: "center", 
                                fontSize: "65px", 
                                fontFamily: "sora",
                                paddingTop: "1%",
                                marginBottom: "0px",
                            }}>Essential Reading</h1>
                            <h2 style={{textAlign: "center", fontFamily: "sora"}}>Before you consider buying, I highly recommend you read the following:</h2>
                            <div className='essentialReadings'>
                                <div className='reading'>
                                    <div style={{width: "85%"}} className='readingCard'>
                                        <img src='/assets/hbr-logo.png'/>
                                        <h3 style={{color: "#0930cb"}}>Title: <label style={{color: "#321d05"}}>Do Rewards Really Create Loyalty?</label></h3>
                                        <p>(20 mins)</p>
                                        <button onClick={this.goToArticle1}><a style={{textDecoration: "none", color: "white"}} target='_blank' href='https://hbr.org/1995/05/do-rewards-really-create-loyalty'>Read</a></button>
                                    </div>
                                </div>
                                <div className='reading'>
                                    <div style={{width: "85%"}} className='readingCard'>
                                        <img style={{marginTop: "10%"}} src='/assets/sloan-logo.png'/>
                                        <h3 style={{color: "#0930cb"}}>Title: <label style={{color: "#321d05"}}>Do Customer Loyalty Programs Really Work?</label></h3>
                                        <p>(35 mins)</p>
                                        <button onClick={this.goToArticle2}><a style={{textDecoration: "none", color: "white"}} target='_blank' href='https://www.researchgate.net/publication/290890144_Do_Customer_Loyalty_Programs_Really_Work'>Read</a></button>
                                    </div>
                                </div>
                                <div className='reading'>
                                    <div style={{width: "85%"}} className='readingCard2'>
                                        <img style={{marginTop: "0%", width: "95%"}} src='/assets/hubspot-logo.jpeg'/>
                                        <h3 style={{color: "#0930cb"}}>Title: <label style={{color: "#321d05"}}>The Beginner's Guide to Building a Customer Loyalty Program</label></h3>
                                        <p>(20 mins)</p>
                                        <button onClick={this.goToArticle3}><a style={{textDecoration: "none", color: "white"}} target='_blank' href='https://blog.hubspot.com/service/customer-loyalty-program'>Read</a></button>
                                    </div>
                                </div>
                            </div>
                            <div style={{width: "100%"}} className='usefulQuotes'>
                                <div className="quoteOverlay">
                                    <div className='quoteCol'>
                                        <h2 style={{
                                            marginTop: "95.5%", 
                                            paddingLeft: "0%", 
                                            paddingRight: "1.5%",
                                            fontFamily: "sora",
                                            color: "#321d05",
                                            marginBottom: "3%",
                                            fontSize: "24px"
                                            // fontSize: "100%"
                                        }}>Starbucks Rewards members accounted for 55% of sales at US company-operated stores...</h2>
                                        <p><a target='_blank' href='https://africa.businessinsider.com/retail/customers-might-hate-starbucks-new-reward-program-but-wall-street-loves-it/4qmd6x6'> - Business Insider</a></p>
                                    </div>
                                    <div style={{
                                        marginTop: "38.5%", 
                                        paddingLeft: "0%", 
                                        paddingRight: "2.5%",
                                        fontFamily: "sora",
                                        color: "#321d05",
                                        marginBottom: "2%",
                                        fontSize: "14px"
                                    }} className='quoteCol'>
                                        <h2>It's more cost-effective for your business to retain happy customers than acquire new ones. Acquiring a new customer is 5-25X more expensive than retaining a current one.</h2>
                                        <p><a target='_blank' href='https://blog.hubspot.com/service/customer-loyalty-program'> - HubSpot</a></p>
                                    </div>
                                    <div style={{
                                        marginTop: "30.5%", 
                                        paddingLeft: "0%", 
                                        paddingRight: "1.5%",
                                        fontFamily: "sora",
                                        color: "#321d05",
                                        marginBottom: "2%",
                                        fontSize: "14px"
                                    }} className='quoteCol'>
                                        <h2>A study by McKinsey, for example, found that customers who are members of a [paid] loyalty program are 59% more likely to choose a brand over a competitor and 43% more likely to buy weekly.</h2>
                                        <p><a target='_blank' href='https://www.forbes.com/sites/forbestechcouncil/2022/11/18/loyalty-programs-what-works-and-what-doesnt/?sh=4c634a486539'> - Forbes</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id='features' style={{width: "100%", height: "auto", backgroundColor: "#0930cb", marginTop: "3%"}} className='pageBody'>
                            <h1 style=
                            {{
                                color: "white", 
                                textAlign: "center", 
                                fontSize: "65px", 
                                fontFamily: "sora",
                                paddingTop: "2.5%",
                                marginBottom: "0px"
                            }}>Features</h1>
                            <div className='featuresContainer'>
                                <div className='featuresCol1'>
                                    <h1 style={{paddingTop: "2%", fontSize: "34px"}}>
                                        Make quick & easy modifications to your customer-facing web application as needed
                                    </h1>
                                    <h1 style={{paddingTop: "3%", marginBottom: "6%", fontSize: "34px"}}>
                                        Add customization to suit the language and look of your brand 
                                    </h1>
                                </div>
                                <div className='featuresCol2'>
                                    <img src='/assets/featuresRightCol2.png'/>
                                </div>
                            </div>
                            <div style={{width: "100%", textAlign: "center"}} className='pageBodyLeft'>
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    className='pageVideo'
                                >
                                    <source src='/assets/part3HomeSection5.mp4' type='video/mp4' />
                                    {/* You can add additional source elements for different video formats */}
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                            <div style={{textAlign: "center"}} className='pageBodyRight'>
                                {/* <img src='/assets/part2HomeSection2.57.png'/> */}
                            </div>
                        </div>
                        <div style={{width: "100%", height: "auto", backgroundColor: "#0930cb", marginTop: "0px"}} className='pageBody'>
                            {/* <h1 style=
                            {{
                                color: "white", 
                                textAlign: "center", 
                                fontSize: "75px", 
                                fontFamily: "sora",
                                paddingTop: "2.5%",
                                marginBottom: "0px"
                            }}>Features</h1> */}
                            <div className='featuresContainer'>
                                <div className='featuresCol1'>
                                    <img src='/assets/featuresRightCol3.5.png'/>
                                </div>
                                <div className='featuresCol2'>
                                    <h1 style={{paddingTop: "1%", marginRight: "3.5%", marginTop: "1.5%", fontSize: "34px"}}>
                                        Create incentives for customers to spend by offering higher value earning on various purchases
                                    </h1>
                                    <h1 style={{paddingTop: "6%", marginRight: "3.5%", fontSize: "34px"}}>
                                        Create on-menu OR off-menu rewards for your customers in seconds
                                    </h1>
                                </div>
                            </div>
                            <div style={{width: "100%", textAlign: "center"}} className='pageBodyLeft'>
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    className='pageVideo'
                                >
                                    <source src='/assets/part4HomeSection35.mp4' type='video/mp4' />
                                    {/* You can add additional source elements for different video formats */}
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                            <div style={{textAlign: "center"}} className='pageBodyRight'>
                                {/* <img src='/assets/part2HomeSection2.57.png'/> */}
                            </div>
                            <div className='featuresContainer'>
                                <div className='featuresCol1'>
                                    <img src='/assets/featuresRightCol5.6.png'/>
                                </div>
                                <div className='featuresCol2'>
                                    <h1 style={{paddingTop: "1%", marginRight: "3.5%", marginTop: "1.5%", fontSize: "34px"}}>
                                        Segment your customers for better targeted email marketing
                                    </h1>
                                    <h1 style={{paddingTop: "6%", marginRight: "3.5%", fontSize: "34px"}}>
                                        Track analytics for meals, rewards and customer spending all-year round
                                    </h1>
                                </div>
                            </div>
                            <div  className='lastFeatureCol' style={{textAlign: "center", marginBottom: "5%"}}>
                                <button
                                onClick={this.bookCalendarEvent}
                                style={{marginTop: "2%", width: "35%", padding: "3%"}}
                                >Schedule a demo</button>
                            </div>
                        </div>
                        <div id='pricing' style={{textAlign: "center"}}>
                            <h1 style=
                            {{
                                color: "#321d05", 
                                textAlign: "center", 
                                fontSize: "65px", 
                                fontFamily: "sora",
                                marginBottom: "1%"
                            }}>Pricing</h1>
                            <div className='priceTimeFrame'>
                                <button
                                onClick={this.monthlyPriceCardClicked}
                                style={{
                                    backgroundColor: this.state.monthlyBgColor,
                                    color: this.state.monthlyTxtColor,
                                    borderTopLeftRadius: "8px",
                                    borderBottomLeftRadius: "8px",
                                    border: "1px solid #0930cb",
                                    borderRight: "0px solid transparent",
                                    padding: "2%",
                                    width: "15%"
                                }}
                                >Monthly</button>
                                <button
                                onClick={this.yearlyPriceCardClicked}
                                style={{
                                    backgroundColor: this.state.yearlyBgColor,
                                    color: this.state.yearlyTxtColor,
                                    borderTopRightRadius: "8px",
                                    borderBottomRightRadius: "8px",
                                    border: "1px solid #0930cb",
                                    padding: "2%",
                                    width: "15%"
                                }}
                                >Yearly</button>
                            </div>
                            <CSSTransition
                            in={this.state.showMonthlyPriceCard}
                            timeout={500}
                            classNames="dialog-slide"
                            unmountOnExit
                            >
                                <div>
                                    {this.state.showMonthlyPriceCard && 
                                        <div style={{width: "40%"}} className='priceCard'>
                                            <h2>Standard</h2>
                                            <h1>15,000 Kshs<label style={{fontSize: "14px", marginLeft: "1%"}}>/ month</label></h1>
                                            <p>(per branch)</p>
                                            <div style={{marginTop: "8%"}}>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Unlimited customer sign ups</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Unlimited customer rewards</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Unlimited feature access</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>White label branding</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Personalized URL for your brand</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{marginTop: "6.5%"}}>
                                                <button
                                                onClick={this.bookCalendarEvent}
                                                >Get Started</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </CSSTransition>
                            <CSSTransition
                            in={this.state.showYearlyPriceCard}
                            timeout={500}
                            classNames="dialog-slide"
                            unmountOnExit
                            >
                                <div>
                                    {this.state.showYearlyPriceCard && 
                                        <div style={{width: "40%"}} className='priceCard'>
                                            <h2>Standard <label style={{fontSize: "17.5px", color: "red", fontFamily: "rubik", marginLeft: "2%"}}>(Save 33% annually)</label></h2>
                                            <h1>10,000 Kshs<label style={{fontSize: "14px", marginLeft: "1%"}}>/ month</label></h1>
                                            <p>(per branch)</p>
                                            <div style={{marginTop: "8%"}}>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Unlimited customer sign ups</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Unlimited customer rewards</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Unlimited feature access</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>White label branding</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Personalized URL for your brand</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{marginTop: "6.5%"}}>
                                                <button
                                                >Get Started</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </CSSTransition>
                        </div>
                        <div className='footer'>
                            <div className='footerCol1'>
                                <img src="/assets/paper-plane-logo.png"/>
                                <div className='footerSocial'>
                                    {/* <img src='/assets/footer-linkedin.png'/> */}
                                </div>
                                {/* <label style={{marginLeft: "1.5%", color: "white", fontFamily: "sora"}}>kifaa</label> */}
                                {/* <p>© kifaa</p> */}
                            </div>
                            <div className='footerCol2'>
                                <h3>Product</h3>
                                <p onClick={this.handleScrollToFeatures}><label>Features</label></p>
                                <p onClick={this.handleScrollToPricing}><label>Pricing</label></p>
                            </div>
                            <div className='footerCol3'>
                                <h3>Contact</h3>  
                                <p><label>+254717230621</label></p> 
                            </div>
                            <div className='footerCol4'>
                                {/* <h3>Legal</h3>  
                                <p><label>Terms of use</label></p> 
                                <p><label>Privacy policy</label></p>  */}
                            </div>
                        </div>
                    </div>
                }
                {this.state.showLoadingScreen && 
                    <div className='loadingScreen'>
                        <ClipLoader
                        color="#0930CB"
                        loading={true}
                        // cssOverride={override}
                        size={60}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                        />
                    </div>
                }
                {this.state.showSignUpBusinessPage &&
                    <div className=''>
                        <SignUpBusiness/>
                    </div>
                }
            </div>
        )
    }

    renderLargeDesktopView = () => {
        let loginBtnStyle = {
            backgroundColor: "white",
            border: "2px solid #0930cb",
            color: "#0930cb"
        }
        return (
            <div>
                {this.state.showLandingPage && 
                    <div style={{maxWidth: "100%", overflowX: "none"}}>
                        <div style={{display: "flex", justifyContent: "space-between"}} className='navBar'>
                            <div className='logo'>
                                <h3>kifaa</h3>
                            </div>
                            <div className='user'>
                                <h4><button
                                // style={loginBtnStyle}
                                onClick={this.handleScrollToFeatures}
                                >Features</button></h4>
                            </div>
                            <div className='user'>
                                <h4><button
                                // style={loginBtnStyle}
                                onClick={this.handleScrollToPricing}
                                >Pricing</button></h4>
                            </div>
                        </div>
                        <div className='pageBody'>
                            <div className='pageBodyLeft'>
                                <div className='pageHeader'>
                                    <h1 style={{fontSize: "55px"}}>
                                        <span><u><Typewriter options={{
                                        strings: ["elevate your brand with", 'worthwhile', "personalised", "easy to setup"],
                                        autoStart: true,
                                        loop: true,
                                        }}
                                        /></u></span> rewards for your <label>best</label> customers
                                    </h1>
                                </div>
                                <div className='pagePicture'>
                                    <img src='/assets/customerBackground35.png'/>
                                </div>
                            </div>
                            <div className='pageBodyRight'>
                            <video
                                autoPlay
                                loop
                                muted
                                playsInline
                                className='pageVideo'
                            >
                                <source src='/assets/customerBackgroundRight3.5.mp4' type='video/mp4' />
                                {/* You can add additional source elements for different video formats */}
                                Your browser does not support the video tag.
                            </video>
                                <div className='requestDemoBtn'>
                                    <button
                                    style={{width: "70%", padding: "6.5%"}}
                                    onClick={this.bookCalendarEvent}
                                    >Schedule Demo</button>
                                </div>
                            </div>
                        </div>
                        <div className='pageBody'>
                            <div style={{width: "25%", textAlign: "right"}} className='pageBodyRight'>
                                <img src='/assets/part2.55HomeSection56.png'/>
                            </div>
                            <div style={{textAlign: "center"}} className='pageBodyLeft'>
                                <img src='/assets/part2HomeSection2.97.png'/>
                            </div>
                        </div>
                        <div className='pageBody' style={{width: "100%", height: "auto"}}>
                            <h1 style=
                            {{
                                marginTop: "1.5%",
                                color: "#321d05", 
                                textAlign: "center", 
                                fontSize: "70.5px", 
                                fontFamily: "sora",
                                paddingTop: "1%",
                                marginBottom: "0px",
                            }}>Essential Reading</h1>
                            <h2 style={{textAlign: "center", fontFamily: "sora"}}>Before you consider buying, I highly recommend you read the following:</h2>
                            <div className='essentialReadings'>
                                <div className='reading'>
                                    <div style={{width: "85%"}} className='readingCard'>
                                        <img src='/assets/hbr-logo.png'/>
                                        <h3 style={{color: "#0930cb"}}>Title: <label style={{color: "#321d05"}}>Do Rewards Really Create Loyalty?</label></h3>
                                        <p>(20 mins)</p>
                                        <button onClick={this.goToArticle1}><a style={{textDecoration: "none", color: "white"}} target='_blank' href='https://hbr.org/1995/05/do-rewards-really-create-loyalty'>Read</a></button>
                                    </div>
                                </div>
                                <div className='reading'>
                                    <div style={{width: "85%"}} className='readingCard'>
                                        <img style={{marginTop: "10%"}} src='/assets/sloan-logo.png'/>
                                        <h3 style={{color: "#0930cb"}}>Title: <label style={{color: "#321d05"}}>Do Customer Loyalty Programs Really Work?</label></h3>
                                        <p>(35 mins)</p>
                                        <button onClick={this.goToArticle2}><a style={{textDecoration: "none", color: "white"}} target='_blank' href='https://www.researchgate.net/publication/290890144_Do_Customer_Loyalty_Programs_Really_Work'>Read</a></button>
                                    </div>
                                </div>
                                <div className='reading'>
                                    <div style={{width: "85%"}} className='readingCard2'>
                                        <img style={{marginTop: "0%", width: "95%"}} src='/assets/hubspot-logo.jpeg'/>
                                        <h3 style={{color: "#0930cb"}}>Title: <label style={{color: "#321d05"}}>The Beginner's Guide to Building a Customer Loyalty Program</label></h3>
                                        <p>(20 mins)</p>
                                        <button onClick={this.goToArticle3}><a style={{textDecoration: "none", color: "white"}} target='_blank' href='https://blog.hubspot.com/service/customer-loyalty-program'>Read</a></button>
                                    </div>
                                </div>
                            </div>
                            <div style={{width: "100%"}} className='usefulQuotes'>
                                <div className="quoteOverlay">
                                    <div className='quoteCol'>
                                        <h2 style={{
                                            marginTop: "95.5%", 
                                            paddingLeft: "0%", 
                                            paddingRight: "1.5%",
                                            fontFamily: "sora",
                                            color: "#321d05",
                                            marginBottom: "3%",
                                            fontSize: "21px"
                                            // fontSize: "100%"
                                        }}>Starbucks Rewards members accounted for 55% of sales at US company-operated stores...</h2>
                                        <p><a target='_blank' href='https://africa.businessinsider.com/retail/customers-might-hate-starbucks-new-reward-program-but-wall-street-loves-it/4qmd6x6'> - Business Insider</a></p>
                                    </div>
                                    <div style={{
                                        marginTop: "36.5%", 
                                        paddingLeft: "0%", 
                                        paddingRight: "2.5%",
                                        fontFamily: "sora",
                                        color: "#321d05",
                                        marginBottom: "2%",
                                        fontSize: "13px"
                                    }} className='quoteCol'>
                                        <h2>It's more cost-effective for your business to retain happy customers than acquire new ones. Acquiring a new customer is 5-25X more expensive than retaining a current one.</h2>
                                        <p><a target='_blank' href='https://blog.hubspot.com/service/customer-loyalty-program'> - HubSpot</a></p>
                                    </div>
                                    <div style={{
                                        marginTop: "30.5%", 
                                        paddingLeft: "0%", 
                                        paddingRight: "1.5%",
                                        fontFamily: "sora",
                                        color: "#321d05",
                                        marginBottom: "2%",
                                        fontSize: "13px"
                                    }} className='quoteCol'>
                                        <h2>A study by McKinsey, for example, found that customers who are members of a [paid] loyalty program are 59% more likely to choose a brand over a competitor and 43% more likely to buy weekly.</h2>
                                        <p><a target='_blank' href='https://www.forbes.com/sites/forbestechcouncil/2022/11/18/loyalty-programs-what-works-and-what-doesnt/?sh=4c634a486539'> - Forbes</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id='features' style={{width: "100%", height: "auto", backgroundColor: "#0930cb", marginTop: "3%"}} className='pageBody'>
                            <h1 style=
                            {{
                                color: "white", 
                                textAlign: "center", 
                                fontSize: "70.5px", 
                                fontFamily: "sora",
                                paddingTop: "2.5%",
                                marginBottom: "0px"
                            }}>Features</h1>
                            <div className='featuresContainer'>
                                <div className='featuresCol1'>
                                    <h1 style={{paddingTop: "2%", fontSize: "34px"}}>
                                        Make quick & easy modifications to your customer-facing web application as needed
                                    </h1>
                                    <h1 style={{paddingTop: "3%", marginBottom: "6%", fontSize: "34px"}}>
                                        Add customization to suit the language and look of your brand 
                                    </h1>
                                </div>
                                <div className='featuresCol2'>
                                    <img src='/assets/featuresRightCol2.png'/>
                                </div>
                            </div>
                            <div style={{width: "100%", textAlign: "center"}} className='pageBodyLeft'>
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    className='pageVideo'
                                >
                                    <source src='/assets/part3HomeSection5.mp4' type='video/mp4' />
                                    {/* You can add additional source elements for different video formats */}
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                            <div style={{textAlign: "center"}} className='pageBodyRight'>
                                {/* <img src='/assets/part2HomeSection2.57.png'/> */}
                            </div>
                        </div>
                        <div style={{width: "100%", height: "auto", backgroundColor: "#0930cb", marginTop: "0px"}} className='pageBody'>
                            {/* <h1 style=
                            {{
                                color: "white", 
                                textAlign: "center", 
                                fontSize: "75px", 
                                fontFamily: "sora",
                                paddingTop: "2.5%",
                                marginBottom: "0px"
                            }}>Features</h1> */}
                            <div className='featuresContainer'>
                                <div className='featuresCol1'>
                                    <img src='/assets/featuresRightCol3.5.png'/>
                                </div>
                                <div className='featuresCol2'>
                                    <h1 style={{paddingTop: "1%", marginRight: "3.5%", marginTop: "1.5%", fontSize: "34px"}}>
                                        Create incentives for customers to spend by offering higher value earning on various purchases
                                    </h1>
                                    <h1 style={{paddingTop: "6%", marginRight: "3.5%", fontSize: "34px"}}>
                                        Create on-menu OR off-menu rewards for your customers in seconds
                                    </h1>
                                </div>
                            </div>
                            <div style={{width: "100%", textAlign: "center"}} className='pageBodyLeft'>
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    className='pageVideo'
                                >
                                    <source src='/assets/part4HomeSection35.mp4' type='video/mp4' />
                                    {/* You can add additional source elements for different video formats */}
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                            <div style={{textAlign: "center"}} className='pageBodyRight'>
                                {/* <img src='/assets/part2HomeSection2.57.png'/> */}
                            </div>
                            <div className='featuresContainer'>
                                <div className='featuresCol1'>
                                    <img src='/assets/featuresRightCol5.6.png'/>
                                </div>
                                <div className='featuresCol2'>
                                    <h1 style={{paddingTop: "1%", marginRight: "3.5%", marginTop: "1.5%", fontSize: "34px"}}>
                                        Segment your customers for better targeted email marketing
                                    </h1>
                                    <h1 style={{paddingTop: "6%", marginRight: "3.5%", fontSize: "34px"}}>
                                        Track analytics for meals, rewards and customer spending all-year round
                                    </h1>
                                </div>
                            </div>
                            <div  className='lastFeatureCol' style={{textAlign: "center", marginBottom: "5%"}}>
                                <button
                                onClick={this.bookCalendarEvent}
                                style={{marginTop: "2%", width: "30%", padding: "2.75%"}}
                                >Schedule a demo</button>
                            </div>
                        </div>
                        <div id='pricing' style={{textAlign: "center"}}>
                            <h1 style=
                            {{
                                color: "#321d05", 
                                textAlign: "center", 
                                fontSize: "70.5px", 
                                fontFamily: "sora",
                                marginBottom: "1%"
                            }}>Pricing</h1>
                            <div className='priceTimeFrame'>
                                <button
                                onClick={this.monthlyPriceCardClicked}
                                style={{
                                    backgroundColor: this.state.monthlyBgColor,
                                    color: this.state.monthlyTxtColor,
                                    borderTopLeftRadius: "8px",
                                    borderBottomLeftRadius: "8px",
                                    border: "1px solid #0930cb",
                                    borderRight: "0px solid transparent",
                                    padding: "2%",
                                    width: "15%"
                                }}
                                >Monthly</button>
                                <button
                                onClick={this.yearlyPriceCardClicked}
                                style={{
                                    backgroundColor: this.state.yearlyBgColor,
                                    color: this.state.yearlyTxtColor,
                                    borderTopRightRadius: "8px",
                                    borderBottomRightRadius: "8px",
                                    border: "1px solid #0930cb",
                                    padding: "2%",
                                    width: "15%"
                                }}
                                >Yearly</button>
                            </div>
                            <CSSTransition
                            in={this.state.showMonthlyPriceCard}
                            timeout={500}
                            classNames="dialog-slide"
                            unmountOnExit
                            >
                                <div>
                                    {this.state.showMonthlyPriceCard && 
                                        <div style={{width: "42.5%"}} className='priceCard'>
                                            <h2>Standard</h2>
                                            <h1>15,000 Kshs<label style={{fontSize: "14px", marginLeft: "1%"}}>/ month</label></h1>
                                            <p>(per branch)</p>
                                            <div style={{marginTop: "8%"}}>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Unlimited customer sign ups</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Unlimited customer rewards</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Unlimited feature access</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>White label branding</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Personalized URL for your brand</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{marginTop: "6.5%"}}>
                                                <button
                                                onClick={this.bookCalendarEvent}
                                                >Get Started</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </CSSTransition>
                            <CSSTransition
                            in={this.state.showYearlyPriceCard}
                            timeout={500}
                            classNames="dialog-slide"
                            unmountOnExit
                            >
                                <div>
                                    {this.state.showYearlyPriceCard && 
                                        <div style={{width: "42.5%"}} className='priceCard'>
                                            <h2>Standard <label style={{fontSize: "17.5px", color: "red", fontFamily: "rubik", marginLeft: "2%"}}>(Save 33% annually)</label></h2>
                                            <h1>10,000 Kshs<label style={{fontSize: "14px", marginLeft: "1%"}}>/ month</label></h1>
                                            <p>(per branch)</p>
                                            <div style={{marginTop: "8%"}}>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Unlimited customer sign ups</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Unlimited customer rewards</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Unlimited feature access</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>White label branding</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p>Personalized URL for your brand</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{marginTop: "6.5%"}}>
                                                <button
                                                >Get Started</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </CSSTransition>
                        </div>
                        <div className='footer'>
                            <div className='footerCol1'>
                                <img src="/assets/paper-plane-logo.png"/>
                                <div className='footerSocial'>
                                    {/* <img src='/assets/footer-linkedin.png'/> */}
                                </div>
                                {/* <label style={{marginLeft: "1.5%", color: "white", fontFamily: "sora"}}>kifaa</label> */}
                                {/* <p>© kifaa</p> */}
                            </div>
                            <div className='footerCol2'>
                                <h3>Product</h3>
                                <p onClick={this.handleScrollToFeatures}><label>Features</label></p>
                                <p onClick={this.handleScrollToPricing}><label>Pricing</label></p>
                            </div>
                            <div className='footerCol3'>
                                <h3>Contact</h3>  
                                <p><label>+254717230621</label></p> 
                            </div>
                            <div className='footerCol4'>
                                {/* <h3>Legal</h3>  
                                <p><label>Terms of use</label></p> 
                                <p><label>Privacy policy</label></p>  */}
                            </div>
                        </div>
                    </div>
                }
                {this.state.showLoadingScreen && 
                    <div className='loadingScreen'>
                        <ClipLoader
                        color="#0930CB"
                        loading={true}
                        // cssOverride={override}
                        size={60}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                        />
                    </div>
                }
                {this.state.showSignUpBusinessPage &&
                    <div className=''>
                        <SignUpBusiness/>
                    </div>
                }
            </div>
        )
    }

    renderLargestDesktopView = () => {
        let loginBtnStyle = {
            backgroundColor: "white",
            border: "2px solid #0930cb",
            color: "#0930cb"
        }
        return (
            <div>
                {this.state.showLandingPage && 
                    <div style={{maxWidth: "100%", overflowX: "none"}}>
                        <div style={{display: "flex", justifyContent: "space-between"}} className='navBar'>
                            <div className='logo'>
                                <h3>kifaa</h3>
                            </div>
                            <div className='user'>
                                <h4><button
                                // style={loginBtnStyle}
                                onClick={this.handleScrollToFeatures}
                                >Features</button></h4>
                            </div>
                            <div className='user'>
                                <h4><button
                                // style={loginBtnStyle}
                                onClick={this.handleScrollToPricing}
                                >Pricing</button></h4>
                            </div>
                        </div>
                        <div className='pageBody'>
                            <div className='pageBodyLeft'>
                                <div className='pageHeader'>
                                    <h1 style={{fontSize: "55px"}}>
                                        <span><u><Typewriter options={{
                                        strings: ["elevate your brand with", 'worthwhile', "personalised", "easy to setup"],
                                        autoStart: true,
                                        loop: true,
                                        }}
                                        /></u></span> rewards for your <label>best</label> customers
                                    </h1>
                                </div>
                                <div className='pagePicture'>
                                    <img src='/assets/customerBackground35.png'/>
                                </div>
                            </div>
                            <div className='pageBodyRight'>
                            <video
                                autoPlay
                                loop
                                muted
                                playsInline
                                className='pageVideo'
                            >
                                <source src='/assets/customerBackgroundRight3.5.mp4' type='video/mp4' />
                                {/* You can add additional source elements for different video formats */}
                                Your browser does not support the video tag.
                            </video>
                                <div className='requestDemoBtn'>
                                    <button
                                    style={{width: "70%", padding: "6.5%"}}
                                    onClick={this.bookCalendarEvent}
                                    >Schedule Demo</button>
                                </div>
                            </div>
                        </div>
                        <div className='pageBody'>
                            <div style={{width: "25%", textAlign: "right"}} className='pageBodyRight'>
                                <img src='/assets/part2.55HomeSection56.png'/>
                            </div>
                            <div style={{textAlign: "center"}} className='pageBodyLeft'>
                                <img src='/assets/part2HomeSection2.97.png'/>
                            </div>
                        </div>
                        <div className='pageBody' style={{width: "100%", height: "auto"}}>
                            <h1 style=
                            {{
                                marginTop: "1.5%",
                                color: "#321d05", 
                                textAlign: "center", 
                                fontSize: "70.5px", 
                                fontFamily: "sora",
                                paddingTop: "1%",
                                marginBottom: "0px",
                            }}>Essential Reading</h1>
                            <h2 style={{textAlign: "center", fontFamily: "sora"}}>Before you consider buying, I highly recommend you read the following:</h2>
                            <div className='essentialReadings'>
                                <div className='reading'>
                                    <div style={{width: "87.5%"}} className='readingCard'>
                                        <img src='/assets/hbr-logo.png'/>
                                        <h3 style={{color: "#0930cb"}}>Title: <label style={{color: "#321d05"}}>Do Rewards Really Create Loyalty?</label></h3>
                                        <p>(20 mins)</p>
                                        <button onClick={this.goToArticle1}><a style={{textDecoration: "none", color: "white"}} target='_blank' href='https://hbr.org/1995/05/do-rewards-really-create-loyalty'>Read</a></button>
                                    </div>
                                </div>
                                <div className='reading'>
                                    <div style={{width: "87.5%"}} className='readingCard'>
                                        <img style={{marginTop: "10%"}} src='/assets/sloan-logo.png'/>
                                        <h3 style={{color: "#0930cb"}}>Title: <label style={{color: "#321d05"}}>Do Customer Loyalty Programs Really Work?</label></h3>
                                        <p>(35 mins)</p>
                                        <button onClick={this.goToArticle2}><a style={{textDecoration: "none", color: "white"}} target='_blank' href='https://www.researchgate.net/publication/290890144_Do_Customer_Loyalty_Programs_Really_Work'>Read</a></button>
                                    </div>
                                </div>
                                <div className='reading'>
                                    <div style={{width: "87.5%"}} className='readingCard2'>
                                        <img style={{marginTop: "0%", width: "95%"}} src='/assets/hubspot-logo.jpeg'/>
                                        <h3 style={{color: "#0930cb"}}>Title: <label style={{color: "#321d05"}}>The Beginner's Guide to Building a Customer Loyalty Program</label></h3>
                                        <p>(20 mins)</p>
                                        <button onClick={this.goToArticle3}><a style={{textDecoration: "none", color: "white"}} target='_blank' href='https://blog.hubspot.com/service/customer-loyalty-program'>Read</a></button>
                                    </div>
                                </div>
                            </div>
                            <div style={{width: "100%"}} className='usefulQuotes'>
                                <div className="quoteOverlay">
                                    <div className='quoteCol'>
                                        <h2 style={{
                                            marginTop: "95.5%", 
                                            paddingLeft: "0%", 
                                            paddingRight: "1.5%",
                                            fontFamily: "sora",
                                            color: "#321d05",
                                            marginBottom: "3%",
                                            fontSize: "22px"
                                            // fontSize: "100%"
                                        }}>Starbucks Rewards members accounted for 55% of sales at US company-operated stores...</h2>
                                        <p><a target='_blank' href='https://africa.businessinsider.com/retail/customers-might-hate-starbucks-new-reward-program-but-wall-street-loves-it/4qmd6x6'> - Business Insider</a></p>
                                    </div>
                                    <div style={{
                                        marginTop: "34.5%", 
                                        paddingLeft: "0%", 
                                        paddingRight: "2.5%",
                                        fontFamily: "sora",
                                        color: "#321d05",
                                        marginBottom: "2%",
                                        fontSize: "14px"
                                    }} className='quoteCol'>
                                        <h2>It's more cost-effective for your business to retain happy customers than acquire new ones. Acquiring a new customer is 5-25X more expensive than retaining a current one.</h2>
                                        <p><a target='_blank' href='https://blog.hubspot.com/service/customer-loyalty-program'> - HubSpot</a></p>
                                    </div>
                                    <div style={{
                                        marginTop: "28.5%", 
                                        paddingLeft: "0%", 
                                        paddingRight: "1.5%",
                                        fontFamily: "sora",
                                        color: "#321d05",
                                        marginBottom: "2%",
                                        fontSize: "14px"
                                    }} className='quoteCol'>
                                        <h2>A study by McKinsey, for example, found that customers who are members of a [paid] loyalty program are 59% more likely to choose a brand over a competitor and 43% more likely to buy weekly.</h2>
                                        <p><a target='_blank' href='https://www.forbes.com/sites/forbestechcouncil/2022/11/18/loyalty-programs-what-works-and-what-doesnt/?sh=4c634a486539'> - Forbes</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id='features' style={{width: "100%", height: "auto", backgroundColor: "#0930cb", marginTop: "3%"}} className='pageBody'>
                            <h1 style=
                            {{
                                color: "white", 
                                textAlign: "center", 
                                fontSize: "70.5px", 
                                fontFamily: "sora",
                                paddingTop: "2.5%",
                                marginBottom: "0px"
                            }}>Features</h1>
                            <div className='featuresContainer'>
                                <div className='featuresCol1'>
                                    <h1 style={{paddingTop: "2%", fontSize: "34px"}}>
                                        Make quick & easy modifications to your customer-facing web application as needed
                                    </h1>
                                    <h1 style={{paddingTop: "3%", marginBottom: "6%", fontSize: "34px"}}>
                                        Add customization to suit the language and look of your brand 
                                    </h1>
                                </div>
                                <div className='featuresCol2'>
                                    <img src='/assets/featuresRightCol2.png'/>
                                </div>
                            </div>
                            <div style={{width: "100%", textAlign: "center"}} className='pageBodyLeft'>
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    className='pageVideo'
                                >
                                    <source src='/assets/part3HomeSection5.mp4' type='video/mp4' />
                                    {/* You can add additional source elements for different video formats */}
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                            <div style={{textAlign: "center"}} className='pageBodyRight'>
                                {/* <img src='/assets/part2HomeSection2.57.png'/> */}
                            </div>
                        </div>
                        <div style={{width: "100%", height: "auto", backgroundColor: "#0930cb", marginTop: "0px"}} className='pageBody'>
                            {/* <h1 style=
                            {{
                                color: "white", 
                                textAlign: "center", 
                                fontSize: "75px", 
                                fontFamily: "sora",
                                paddingTop: "2.5%",
                                marginBottom: "0px"
                            }}>Features</h1> */}
                            <div className='featuresContainer'>
                                <div className='featuresCol1'>
                                    <img src='/assets/featuresRightCol3.5.png'/>
                                </div>
                                <div className='featuresCol2'>
                                    <h1 style={{paddingTop: "1%", marginRight: "3.5%", marginTop: "1.5%", fontSize: "34px"}}>
                                        Create incentives for customers to spend by offering higher value earning on various purchases
                                    </h1>
                                    <h1 style={{paddingTop: "6%", marginRight: "3.5%", fontSize: "34px"}}>
                                        Create on-menu OR off-menu rewards for your customers in seconds
                                    </h1>
                                </div>
                            </div>
                            <div style={{width: "100%", textAlign: "center"}} className='pageBodyLeft'>
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    className='pageVideo'
                                >
                                    <source src='/assets/part4HomeSection35.mp4' type='video/mp4' />
                                    {/* You can add additional source elements for different video formats */}
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                            <div style={{textAlign: "center"}} className='pageBodyRight'>
                                {/* <img src='/assets/part2HomeSection2.57.png'/> */}
                            </div>
                            <div className='featuresContainer'>
                                <div className='featuresCol1'>
                                    <img src='/assets/featuresRightCol5.6.png'/>
                                </div>
                                <div className='featuresCol2'>
                                    <h1 style={{paddingTop: "1%", marginRight: "3.5%", marginTop: "1.5%", fontSize: "34px"}}>
                                        Segment your customers for better targeted email marketing
                                    </h1>
                                    <h1 style={{paddingTop: "6%", marginRight: "3.5%", fontSize: "34px"}}>
                                        Track analytics for meals, rewards and customer spending all-year round
                                    </h1>
                                </div>
                            </div>
                            <div  className='lastFeatureCol' style={{textAlign: "center", marginBottom: "5%"}}>
                                <button
                                onClick={this.bookCalendarEvent}
                                style={{marginTop: "2%", width: "27.5%", padding: "2.5%"}}
                                >Schedule a demo</button>
                            </div>
                        </div>
                        <div id='pricing' style={{textAlign: "center"}}>
                            <h1 style=
                            {{
                                color: "#321d05", 
                                textAlign: "center", 
                                fontSize: "70.5px", 
                                fontFamily: "sora",
                                marginBottom: "1%"
                            }}>Pricing</h1>
                            <div className='priceTimeFrame'>
                                <button
                                onClick={this.monthlyPriceCardClicked}
                                style={{
                                    backgroundColor: this.state.monthlyBgColor,
                                    color: this.state.monthlyTxtColor,
                                    borderTopLeftRadius: "8px",
                                    borderBottomLeftRadius: "8px",
                                    border: "1px solid #0930cb",
                                    borderRight: "0px solid transparent",
                                    padding: "2%",
                                    width: "15%",
                                    fontSize: "16px"
                                }}
                                >Monthly</button>
                                <button
                                onClick={this.yearlyPriceCardClicked}
                                style={{
                                    backgroundColor: this.state.yearlyBgColor,
                                    color: this.state.yearlyTxtColor,
                                    borderTopRightRadius: "8px",
                                    borderBottomRightRadius: "8px",
                                    border: "1px solid #0930cb",
                                    padding: "2%",
                                    width: "15%",
                                    fontSize: "16px"
                                }}
                                >Yearly</button>
                            </div>
                            <CSSTransition
                            in={this.state.showMonthlyPriceCard}
                            timeout={500}
                            classNames="dialog-slide"
                            unmountOnExit
                            >
                                <div>
                                    {this.state.showMonthlyPriceCard && 
                                        <div style={{width: "37.5%"}} className='priceCard'>
                                            <h2>Standard</h2>
                                            <h1 style={{fontSize: "63.5px"}}>15,000 Kshs<label style={{fontSize: "18px", marginLeft: "1%"}}>/ month</label></h1>
                                            <p style={{fontSize: "18px"}}>(per branch)</p>
                                            <div style={{marginTop: "8%"}}>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p style={{paddingTop: "0.8%", fontSize: "15px"}}>Unlimited customer sign ups</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p style={{paddingTop: "0.8%", fontSize: "15px"}}>Unlimited customer rewards</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p style={{paddingTop: "0.8%", fontSize: "15px"}}>Unlimited feature access</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p style={{paddingTop: "0.8%", fontSize: "15px"}}>White label branding</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p style={{paddingTop: "0.8%", fontSize: "15px"}}>Personalized URL for your brand</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{marginTop: "6.5%"}}>
                                                <button
                                                style={{fontSize: "17.5px"}}
                                                onClick={this.bookCalendarEvent}
                                                >Get Started</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </CSSTransition>
                            <CSSTransition
                            in={this.state.showYearlyPriceCard}
                            timeout={500}
                            classNames="dialog-slide"
                            unmountOnExit
                            >
                                <div>
                                    {this.state.showYearlyPriceCard && 
                                        <div style={{width: "42.5%"}} className='priceCard'>
                                            <h2>Standard <label style={{fontSize: "17.5px", color: "red", fontFamily: "rubik", marginLeft: "2%"}}>(Save 33% annually)</label></h2>
                                            <h1>10,000 Kshs<label style={{fontSize: "14px", marginLeft: "1%"}}>/ month</label></h1>
                                            <p>(per branch)</p>
                                            <div style={{marginTop: "8%"}}>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p style={{paddingTop: "0.8%", fontSize: "15px"}}>Unlimited customer sign ups</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p style={{paddingTop: "0.8%", fontSize: "15px"}}>Unlimited customer rewards</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p style={{paddingTop: "0.8%", fontSize: "15px"}}>Unlimited feature access</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p style={{paddingTop: "0.8%", fontSize: "15px"}}>White label branding</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p style={{paddingTop: "0.8%", fontSize: "15px"}}>Personalized URL for your brand</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{marginTop: "6.5%"}}>
                                                <button
                                                style={{fontSize: "17.5px"}}
                                                >Get Started</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </CSSTransition>
                        </div>
                        <div className='footer'>
                            <div className='footerCol1'>
                                <img src="/assets/paper-plane-logo.png"/>
                                <div className='footerSocial'>
                                    {/* <img src='/assets/footer-linkedin.png'/> */}
                                </div>
                                {/* <label style={{marginLeft: "1.5%", color: "white", fontFamily: "sora"}}>kifaa</label> */}
                                {/* <p>© kifaa</p> */}
                            </div>
                            <div className='footerCol2'>
                                <h3>Product</h3>
                                <p onClick={this.handleScrollToFeatures}><label>Features</label></p>
                                <p onClick={this.handleScrollToPricing}><label>Pricing</label></p>
                            </div>
                            <div className='footerCol3'>
                                <h3>Contact</h3>  
                                <p><label>+254717230621</label></p> 
                            </div>
                            <div className='footerCol4'>
                                {/* <h3>Legal</h3>  
                                <p><label>Terms of use</label></p> 
                                <p><label>Privacy policy</label></p>  */}
                            </div>
                        </div>
                    </div>
                }
                {this.state.showLoadingScreen && 
                    <div className='loadingScreen'>
                        <ClipLoader
                        color="#0930CB"
                        loading={true}
                        // cssOverride={override}
                        size={60}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                        />
                    </div>
                }
                {this.state.showSignUpBusinessPage &&
                    <div className=''>
                        <SignUpBusiness/>
                    </div>
                }
            </div>
        )
    }

    renderFinalDesktopView = () => {
        let loginBtnStyle = {
            backgroundColor: "white",
            border: "2px solid #0930cb",
            color: "#0930cb"
        }
        return (
            <div>
                {this.state.showLandingPage && 
                    <div style={{maxWidth: "100%", overflowX: "none"}}>
                        <div style={{display: "flex", justifyContent: "space-between"}} className='navBar'>
                            <div className='logo'>
                                <h3>kifaa</h3>
                            </div>
                            <div className='user'>
                                <h4><button
                                // style={loginBtnStyle}
                                onClick={this.handleScrollToFeatures}
                                >Features</button></h4>
                            </div>
                            <div className='user'>
                                <h4><button
                                // style={loginBtnStyle}
                                onClick={this.handleScrollToPricing}
                                >Pricing</button></h4>
                            </div>
                        </div>
                        <div className='pageBody'>
                            <div className='pageBodyLeft'>
                                <div className='pageHeader'>
                                    <h1 style={{fontSize: "55px"}}>
                                        <span><u><Typewriter options={{
                                        strings: ["elevate your brand with", 'worthwhile', "personalised", "easy to setup"],
                                        autoStart: true,
                                        loop: true,
                                        }}
                                        /></u></span> rewards for your <label>best</label> customers
                                    </h1>
                                </div>
                                <div className='pagePicture'>
                                    <img src='/assets/customerBackground35.png'/>
                                </div>
                            </div>
                            <div className='pageBodyRight'>
                            <video
                                autoPlay
                                loop
                                muted
                                playsInline
                                className='pageVideo'
                            >
                                <source src='/assets/customerBackgroundRight3.5.mp4' type='video/mp4' />
                                {/* You can add additional source elements for different video formats */}
                                Your browser does not support the video tag.
                            </video>
                                <div className='requestDemoBtn'>
                                    <button
                                    style={{width: "70%", padding: "6.5%"}}
                                    onClick={this.bookCalendarEvent}
                                    >Schedule Demo</button>
                                </div>
                            </div>
                        </div>
                        <div className='pageBody'>
                            <div style={{width: "25%", textAlign: "right"}} className='pageBodyRight'>
                                <img src='/assets/part2.55HomeSection56.png'/>
                            </div>
                            <div style={{textAlign: "center"}} className='pageBodyLeft'>
                                <img src='/assets/part2HomeSection2.97.png'/>
                            </div>
                        </div>
                        <div className='pageBody' style={{width: "100%", height: "auto"}}>
                            <h1 style=
                            {{
                                marginTop: "1.5%",
                                color: "#321d05", 
                                textAlign: "center", 
                                fontSize: "70.5px", 
                                fontFamily: "sora",
                                paddingTop: "1%",
                                marginBottom: "0px",
                            }}>Essential Reading</h1>
                            <h2 style={{textAlign: "center", fontFamily: "sora"}}>Before you consider buying, I highly recommend you read the following:</h2>
                            <div className='essentialReadings'>
                                <div className='reading'>
                                    <div style={{width: "80.5%"}} className='readingCard'>
                                        <img src='/assets/hbr-logo.png'/>
                                        <h3 style={{color: "#0930cb"}}>Title: <label style={{color: "#321d05"}}>Do Rewards Really Create Loyalty?</label></h3>
                                        <p>(20 mins)</p>
                                        <button onClick={this.goToArticle1}><a style={{textDecoration: "none", color: "white"}} target='_blank' href='https://hbr.org/1995/05/do-rewards-really-create-loyalty'>Read</a></button>
                                    </div>
                                </div>
                                <div className='reading'>
                                    <div style={{width: "80.5%"}} className='readingCard'>
                                        <img style={{marginTop: "10%"}} src='/assets/sloan-logo.png'/>
                                        <h3 style={{color: "#0930cb"}}>Title: <label style={{color: "#321d05"}}>Do Customer Loyalty Programs Really Work?</label></h3>
                                        <p>(35 mins)</p>
                                        <button onClick={this.goToArticle2}><a style={{textDecoration: "none", color: "white"}} target='_blank' href='https://www.researchgate.net/publication/290890144_Do_Customer_Loyalty_Programs_Really_Work'>Read</a></button>
                                    </div>
                                </div>
                                <div className='reading'>
                                    <div style={{width: "80.5%"}} className='readingCard2'>
                                        <img style={{marginTop: "0%", width: "95%"}} src='/assets/hubspot-logo.jpeg'/>
                                        <h3 style={{color: "#0930cb"}}>Title: <label style={{color: "#321d05"}}>The Beginner's Guide to Building a Customer Loyalty Program</label></h3>
                                        <p>(20 mins)</p>
                                        <button onClick={this.goToArticle3}><a style={{textDecoration: "none", color: "white"}} target='_blank' href='https://blog.hubspot.com/service/customer-loyalty-program'>Read</a></button>
                                    </div>
                                </div>
                            </div>
                            <div style={{width: "100%"}} className='usefulQuotes'>
                                <div className="quoteOverlay">
                                    <div className='quoteCol'>
                                        <h2 style={{
                                            marginTop: "85.5%", 
                                            paddingLeft: "0%", 
                                            paddingRight: "1.5%",
                                            fontFamily: "sora",
                                            color: "#321d05",
                                            marginBottom: "3%",
                                            fontSize: "22px"
                                            // fontSize: "100%"
                                        }}>Starbucks Rewards members accounted for 55% of sales at US company-operated stores...</h2>
                                        <p><a target='_blank' href='https://africa.businessinsider.com/retail/customers-might-hate-starbucks-new-reward-program-but-wall-street-loves-it/4qmd6x6'> - Business Insider</a></p>
                                    </div>
                                    <div style={{
                                        marginTop: "32.5%", 
                                        paddingLeft: "0%", 
                                        paddingRight: "2.5%",
                                        fontFamily: "sora",
                                        color: "#321d05",
                                        marginBottom: "2%",
                                        fontSize: "14px"
                                    }} className='quoteCol'>
                                        <h2>It's more cost-effective for your business to retain happy customers than acquire new ones. Acquiring a new customer is 5-25X more expensive than retaining a current one.</h2>
                                        <p><a target='_blank' href='https://blog.hubspot.com/service/customer-loyalty-program'> - HubSpot</a></p>
                                    </div>
                                    <div style={{
                                        marginTop: "26.5%", 
                                        paddingLeft: "0%", 
                                        paddingRight: "1.5%",
                                        fontFamily: "sora",
                                        color: "#321d05",
                                        marginBottom: "2%",
                                        fontSize: "14px"
                                    }} className='quoteCol'>
                                        <h2>A study by McKinsey, for example, found that customers who are members of a [paid] loyalty program are 59% more likely to choose a brand over a competitor and 43% more likely to buy weekly.</h2>
                                        <p><a target='_blank' href='https://www.forbes.com/sites/forbestechcouncil/2022/11/18/loyalty-programs-what-works-and-what-doesnt/?sh=4c634a486539'> - Forbes</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id='features' style={{width: "100%", height: "auto", backgroundColor: "#0930cb", marginTop: "3%"}} className='pageBody'>
                            <h1 style=
                            {{
                                color: "white", 
                                textAlign: "center", 
                                fontSize: "70.5px", 
                                fontFamily: "sora",
                                paddingTop: "2.5%",
                                marginBottom: "0px"
                            }}>Features</h1>
                            <div className='featuresContainer'>
                                <div className='featuresCol1'>
                                    <h1 style={{paddingTop: "2%", fontSize: "34px"}}>
                                        Make quick & easy modifications to your customer-facing web application as needed
                                    </h1>
                                    <h1 style={{paddingTop: "3%", marginBottom: "6%", fontSize: "34px"}}>
                                        Add customization to suit the language and look of your brand 
                                    </h1>
                                </div>
                                <div className='featuresCol2'>
                                    <img src='/assets/featuresRightCol2.png'/>
                                </div>
                            </div>
                            <div style={{width: "100%", textAlign: "center"}} className='pageBodyLeft'>
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    className='pageVideo'
                                >
                                    <source src='/assets/part3HomeSection5.mp4' type='video/mp4' />
                                    {/* You can add additional source elements for different video formats */}
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                            <div style={{textAlign: "center"}} className='pageBodyRight'>
                                {/* <img src='/assets/part2HomeSection2.57.png'/> */}
                            </div>
                        </div>
                        <div style={{width: "100%", height: "auto", backgroundColor: "#0930cb", marginTop: "0px"}} className='pageBody'>
                            {/* <h1 style=
                            {{
                                color: "white", 
                                textAlign: "center", 
                                fontSize: "75px", 
                                fontFamily: "sora",
                                paddingTop: "2.5%",
                                marginBottom: "0px"
                            }}>Features</h1> */}
                            <div className='featuresContainer'>
                                <div className='featuresCol1'>
                                    <img src='/assets/featuresRightCol3.5.png'/>
                                </div>
                                <div className='featuresCol2'>
                                    <h1 style={{paddingTop: "1%", marginRight: "3.5%", marginTop: "1.5%", fontSize: "34px"}}>
                                        Create incentives for customers to spend by offering higher value earning on various purchases
                                    </h1>
                                    <h1 style={{paddingTop: "6%", marginRight: "3.5%", fontSize: "34px"}}>
                                        Create on-menu OR off-menu rewards for your customers in seconds
                                    </h1>
                                </div>
                            </div>
                            <div style={{width: "100%", textAlign: "center"}} className='pageBodyLeft'>
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    className='pageVideo'
                                >
                                    <source src='/assets/part4HomeSection35.mp4' type='video/mp4' />
                                    {/* You can add additional source elements for different video formats */}
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                            <div style={{textAlign: "center"}} className='pageBodyRight'>
                                {/* <img src='/assets/part2HomeSection2.57.png'/> */}
                            </div>
                            <div className='featuresContainer'>
                                <div className='featuresCol1'>
                                    <img src='/assets/featuresRightCol5.6.png'/>
                                </div>
                                <div className='featuresCol2'>
                                    <h1 style={{paddingTop: "1%", marginRight: "3.5%", marginTop: "1.5%", fontSize: "34px"}}>
                                        Segment your customers for better targeted email marketing
                                    </h1>
                                    <h1 style={{paddingTop: "6%", marginRight: "3.5%", fontSize: "34px"}}>
                                        Track analytics for meals, rewards and customer spending all-year round
                                    </h1>
                                </div>
                            </div>
                            <div  className='lastFeatureCol' style={{textAlign: "center", marginBottom: "5%"}}>
                                <button
                                onClick={this.bookCalendarEvent}
                                style={{marginTop: "2%", width: "27.5%", padding: "2.5%"}}
                                >Schedule a demo</button>
                            </div>
                        </div>
                        <div id='pricing' style={{textAlign: "center"}}>
                            <h1 style=
                            {{
                                color: "#321d05", 
                                textAlign: "center", 
                                fontSize: "70.5px", 
                                fontFamily: "sora",
                                marginBottom: "1%"
                            }}>Pricing</h1>
                            <div className='priceTimeFrame'>
                                <button
                                onClick={this.monthlyPriceCardClicked}
                                style={{
                                    backgroundColor: this.state.monthlyBgColor,
                                    color: this.state.monthlyTxtColor,
                                    borderTopLeftRadius: "8px",
                                    borderBottomLeftRadius: "8px",
                                    border: "1px solid #0930cb",
                                    borderRight: "0px solid transparent",
                                    padding: "2%",
                                    width: "15%",
                                    fontSize: "16px"
                                }}
                                >Monthly</button>
                                <button
                                onClick={this.yearlyPriceCardClicked}
                                style={{
                                    backgroundColor: this.state.yearlyBgColor,
                                    color: this.state.yearlyTxtColor,
                                    borderTopRightRadius: "8px",
                                    borderBottomRightRadius: "8px",
                                    border: "1px solid #0930cb",
                                    padding: "2%",
                                    width: "15%",
                                    fontSize: "16px"
                                }}
                                >Yearly</button>
                            </div>
                            <CSSTransition
                            in={this.state.showMonthlyPriceCard}
                            timeout={500}
                            classNames="dialog-slide"
                            unmountOnExit
                            >
                                <div>
                                    {this.state.showMonthlyPriceCard && 
                                        <div style={{width: "37.5%"}} className='priceCard'>
                                            <h2>Standard</h2>
                                            <h1 style={{fontSize: "63.5px"}}>15,000 Kshs<label style={{fontSize: "18px", marginLeft: "1%"}}>/ month</label></h1>
                                            <p style={{fontSize: "18px"}}>(per branch)</p>
                                            <div style={{marginTop: "8%"}}>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p style={{paddingTop: "0.8%", fontSize: "15px"}}>Unlimited customer sign ups</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p style={{paddingTop: "0.8%", fontSize: "15px"}}>Unlimited customer rewards</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p style={{paddingTop: "0.8%", fontSize: "15px"}}>Unlimited feature access</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p style={{paddingTop: "0.8%", fontSize: "15px"}}>White label branding</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p style={{paddingTop: "0.8%", fontSize: "15px"}}>Personalized URL for your brand</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{marginTop: "6.5%"}}>
                                                <button
                                                style={{fontSize: "19.5px"}}
                                                onClick={this.bookCalendarEvent}
                                                >Get Started</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </CSSTransition>
                            <CSSTransition
                            in={this.state.showYearlyPriceCard}
                            timeout={500}
                            classNames="dialog-slide"
                            unmountOnExit
                            >
                                <div>
                                    {this.state.showYearlyPriceCard && 
                                        <div style={{width: "42.5%"}} className='priceCard'>
                                            <h2>Standard <label style={{fontSize: "17.5px", color: "red", fontFamily: "rubik", marginLeft: "2%"}}>(Save 33% annually)</label></h2>
                                            <h1>10,000 Kshs<label style={{fontSize: "14px", marginLeft: "1%"}}>/ month</label></h1>
                                            <p>(per branch)</p>
                                            <div style={{marginTop: "8%"}}>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p style={{paddingTop: "0.8%", fontSize: "15px"}}>Unlimited customer sign ups</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p style={{paddingTop: "0.8%", fontSize: "15px"}}>Unlimited customer rewards</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p style={{paddingTop: "0.8%", fontSize: "15px"}}>Unlimited feature access</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p style={{paddingTop: "0.8%", fontSize: "15px"}}>White label branding</p>
                                                    </div>
                                                </div>
                                                <div className='priceFeatures'>
                                                    <div className='priceFeatureCol1'>
                                                        <img src='/assets/priceFeatureCheck.png'/>
                                                    </div>
                                                    <div className='priceFeatureCol2'>
                                                        <p style={{paddingTop: "0.8%", fontSize: "15px"}}>Personalized URL for your brand</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{marginTop: "6.5%"}}>
                                                <button
                                                style={{fontSize: "19.5px"}}
                                                >Get Started</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </CSSTransition>
                        </div>
                        <div className='footer'>
                            <div className='footerCol1'>
                                <img src="/assets/paper-plane-logo.png"/>
                                <div className='footerSocial'>
                                    {/* <img src='/assets/footer-linkedin.png'/> */}
                                </div>
                                {/* <label style={{marginLeft: "1.5%", color: "white", fontFamily: "sora"}}>kifaa</label> */}
                                {/* <p>© kifaa</p> */}
                            </div>
                            <div className='footerCol2'>
                                <h3>Product</h3>
                                <p onClick={this.handleScrollToFeatures}><label>Features</label></p>
                                <p onClick={this.handleScrollToPricing}><label>Pricing</label></p>
                            </div>
                            <div className='footerCol3'>
                                <h3>Contact</h3>  
                                <p><label>+254717230621</label></p> 
                            </div>
                            <div className='footerCol4'>
                                {/* <h3>Legal</h3>  
                                <p><label>Terms of use</label></p> 
                                <p><label>Privacy policy</label></p>  */}
                            </div>
                        </div>
                    </div>
                }
                {this.state.showLoadingScreen && 
                    <div className='loadingScreen'>
                        <ClipLoader
                        color="#0930CB"
                        loading={true}
                        // cssOverride={override}
                        size={60}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                        />
                    </div>
                }
                {this.state.showSignUpBusinessPage &&
                    <div className=''>
                        <SignUpBusiness/>
                    </div>
                }
            </div>
        )
    }

        //* - - TABLET VIEWS - - *//

    renderTabletView = () => {
        let phoneNumber = "+254717230621"
        return (
            <div>
                <div>
                    <Container>
                        <div style={{display: "flex", justifyContent:"space-between"}}>
                            <h2 style={{paddingLeft: "4%", fontWeight: "bold", paddingTop: "2%", color: "#000", fontSize: "37.5px"}}>kifaa</h2>
                            {/* <div className='navbarContainer'>
                                <img src='/assets/paper-plane-logo.png'/>
                            </div> */}
                            <Button onClick={this.toggleDropdown}>
                                <img className='menu-btn' src='/assets/smallPhoneHomeMenu.png'/>
                            </Button>
                        </div>
                        <CSSTransition
                            in={this.state.isDropdownOpen}
                            timeout={500}
                            classNames="dialog-slide2"
                            unmountOnExit
                            >
                            <Dropdown style={{width: "98%"}} className='dropdown' open={this.state.isDropdownOpen}>
                            {/* <p onClick={this.logout} style={{paddingRight: "2.5%"}}>Logout</p> */}
                            <p onClick={this.handleScrollToFeatures} style={{paddingRight: "2.5%", fontSize: "22.5px"}}> Features</p>
                            <p onClick={this.handleScrollToPricing} style={{paddingRight: "2.5%", fontSize: "22.5px"}}>Pricing</p>
                            {/* <p onClick={this.dropdownOption4Clicked} style={{paddingRight: "2.5%"}}>Challenges</p> */}
                            </Dropdown>
                        </CSSTransition>
                    </Container>
                    <h1 style={{color: "#321d05", marginLeft: "4%", marginRight: "4%", fontSize: "69.5px"}}>
                        <span><u><Typewriter options={{
                        strings: ["elevate your brand w/", 'worthwhile', "personalised", "easy to setup"],
                        autoStart: true,
                        loop: true,
                        }}
                        /></u></span><label style={{color: "#000"}}>rewards for your best customers </label>
                    </h1>
                </div>
                <div style={{paddingBottom: "5%"}} className='smallPhoneVideo'>
                    <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        className='pageVideo'
                    >
                        <source src='/assets/customerBackgroundRight3.5.mp4' type='video/mp4' />
                        {/* You can add additional source elements for different video formats */}
                        Your browser does not support the video tag.
                    </video>
                </div>
                <div id='features' style={{backgroundColor: "#321d05", textAlign: "center", paddingBottom: "5%"}}>
                    <h1 style={{color: "white", fontFamily: "sora", paddingTop: "7.5%", fontSize: "72.5px"}}>Features</h1>
                    <div>
                        <h1 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Make quick & easy modifications to your customer-facing web application as needed</h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawCampaignsVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Add customization to suit the language and look of your brand </h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawCampaigns2Video.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Create incentives for customers to spend by offering higher value earning on various purchases</h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawPolicyVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Create on-menu OR off-menu rewards for your customers in seconds</h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawRewardsVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Segment your customers for better targeted email marketing</h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/membersDemo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Track analytics for meals, rewards and customer spending all-year round</h1>
                        <div className='smallPhoneFeaturesBtn'>
                            <button 
                            onClick={this.bookCalendarEvent}
                            style={{fontSize: "25px"}}
                            >Schedule full product demo</button>
                        </div>
                    </div>
                </div>
                <div id='pricing' style={{textAlign: "center", marginBottom: "10%"}}>
                    <h1 style={{color: "#321d05", fontFamily: "sora", paddingTop: "2.5%", fontSize: "72.5px"}}>Pricing</h1>
                    <div className='priceTimeFrameSmallPhone'>
                        <button
                        onClick={this.monthlyPriceCardClicked}
                        style={{
                            fontSize: "22px",
                            backgroundColor: this.state.monthlyBgColor,
                            color: this.state.monthlyTxtColor,
                            borderTopLeftRadius: "8px",
                            borderBottomLeftRadius: "8px",
                            border: "1px solid #0930cb",
                            borderRight: "0px solid transparent"
                        }}
                        >Monthly</button>
                        <button
                        onClick={this.yearlyPriceCardClicked}
                        style={{
                            fontSize: "22px",
                            backgroundColor: this.state.yearlyBgColor,
                            color: this.state.yearlyTxtColor,
                            borderTopRightRadius: "8px",
                            borderBottomRightRadius: "8px",
                            border: "1px solid #0930cb"
                        }}
                        >Yearly</button>
                    </div>
                    <CSSTransition
                    in={this.state.showMonthlyPriceCard}
                    timeout={500}
                    classNames="dialog-slide"
                    unmountOnExit
                    >
                        <div>
                            {this.state.showMonthlyPriceCard && 
                                <div className='priceCardSmallPhone'>
                                    <h2 style={{fontSize: "50px"}}>Standard</h2>
                                    <h1 style={{fontSize: "89.5px"}}>15,000 Kshs<label style={{fontSize: "23.5px", marginLeft: "1%"}}>/ month</label></h1>
                                    <p style={{fontSize: "25px"}}>(per branch)</p>
                                    <div style={{marginTop: "8%"}}>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "23.5px", paddingTop: "1.75%"}}>Unlimited customer sign ups</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "23.5px", paddingTop: "1.75%"}}>Unlimited customer rewards</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "23.5px", paddingTop: "1.75%"}}>Unlimited feature access</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "23.5px", paddingTop: "1.75%"}}>White label branding</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "23.5px", paddingTop: "1.75%"}}>Personalized URL for your brand</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{marginTop: "6.5%"}}>
                                        <button
                                        style={{fontSize: "25px"}}
                                        onClick={this.bookCalendarEvent}
                                        >Get Started</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </CSSTransition>
                    <CSSTransition
                    in={this.state.showYearlyPriceCard}
                    timeout={500}
                    classNames="dialog-slide"
                    unmountOnExit
                    >
                        <div>
                            {this.state.showYearlyPriceCard && 
                                <div className='priceCardSmallPhone'>
                                    <h2 style={{fontSize: "50px"}}>Standard <label style={{fontSize: "23.5px", color: "red", fontFamily: "rubik", marginLeft: "2%"}}>(Save 33% annually)</label></h2>
                                    <h1 style={{fontSize: "89.5px"}}>10,000 Kshs<label style={{fontSize: "22px", marginLeft: "1%"}}>/ month</label></h1>
                                    <p style={{fontSize: "25px"}}>(per branch)</p>
                                    <div style={{marginTop: "8%"}}>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "23.5px", paddingTop: "1.75%"}}>Unlimited customer sign ups</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "23.5px", paddingTop: "1.75%"}}>Unlimited customer rewards</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "23.5px", paddingTop: "1.75%"}}>Unlimited feature access</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "23.5px", paddingTop: "1.75%"}}>White label branding</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "23.5px", paddingTop: "1.75%"}}>Personalized URL for your brand</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{marginTop: "6.5%"}}>
                                        <button
                                        style={{fontSize: "22px"}}
                                        >Get Started</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </CSSTransition>
                </div>
                <div className='footerSmallPhone'>
                    <div className='footerCol1SmallPhone'>
                        <img src="/assets/paper-plane-logo.png"/>
                        <div className='footerSocial'>
                            {/* <img src='/assets/footer-linkedin.png'/> */}
                        </div>
                        {/* <label style={{marginLeft: "1.5%", color: "white", fontFamily: "sora"}}>kifaa</label> */}
                        {/* <p>© kifaa</p> */}
                    </div>
                    <div className='footerCol2SmallPhone'>
                        <h3 style={{fontSize: "37.5px"}}>Product</h3>
                        <p style={{fontSize: "30px"}}><label onClick={this.handleScrollToFeatures}>Features</label></p>
                        <p style={{fontSize: "30px"}}><label onClick={this.handleScrollToPricing}>Pricing</label></p>
                    </div>
                    <div className='footerCol3SmallPhone'>
                        <h3 style={{fontSize: "37.5px"}}>Contact</h3>  
                        <p style={{fontSize: "30px"}}><label><a href={`tel:${phoneNumber}`}>{phoneNumber}</a></label></p> 
                    </div>
                    <div className='footerCol4'>
                        {/* <h3>Legal</h3>  
                        <p><label>Terms of use</label></p> 
                        <p><label>Privacy policy</label></p>  */}
                    </div>
                </div>
            </div>
        )
    }

    renderLargeTabletView = () => {
        let phoneNumber = "+254717230621"
        return (
            <div>
                <div>
                    <Container>
                        <div style={{display: "flex", justifyContent:"space-between"}}>
                            <h2 style={{paddingLeft: "4%", fontWeight: "bold", paddingTop: "2%", color: "#000", fontSize: "41.5px"}}>kifaa</h2>
                            {/* <div className='navbarContainer'>
                                <img src='/assets/paper-plane-logo.png'/>
                            </div> */}
                            <Button onClick={this.toggleDropdown}>
                                <img style={{width: "30px", height: "30px"}} className='menu-btn' src='/assets/smallPhoneHomeMenu.png'/>
                            </Button>
                        </div>
                        <CSSTransition
                            in={this.state.isDropdownOpen}
                            timeout={500}
                            classNames="dialog-slide2"
                            unmountOnExit
                            >
                            <Dropdown style={{width: "98%"}} className='dropdown' open={this.state.isDropdownOpen}>
                            {/* <p onClick={this.logout} style={{paddingRight: "2.5%"}}>Logout</p> */}
                            <p onClick={this.handleScrollToFeatures} style={{paddingRight: "2.5%", fontSize: "27.5px"}}> Features</p>
                            <p onClick={this.handleScrollToPricing} style={{paddingRight: "2.5%", fontSize: "27.5px"}}>Pricing</p>
                            {/* <p onClick={this.dropdownOption4Clicked} style={{paddingRight: "2.5%"}}>Challenges</p> */}
                            </Dropdown>
                        </CSSTransition>
                    </Container>
                    <h1 style={{color: "#321d05", marginLeft: "4%", marginRight: "4%", fontSize: "79.5px"}}>
                        <span><u><Typewriter options={{
                        strings: ["elevate your brand w/", 'worthwhile', "personalised", "easy to setup"],
                        autoStart: true,
                        loop: true,
                        }}
                        /></u></span><label style={{color: "#000"}}>rewards for your best customers </label>
                    </h1>
                </div>
                <div style={{paddingBottom: "5%"}} className='smallPhoneVideo'>
                    <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        className='pageVideo'
                    >
                        <source src='/assets/customerBackgroundRight3.5.mp4' type='video/mp4' />
                        {/* You can add additional source elements for different video formats */}
                        Your browser does not support the video tag.
                    </video>
                </div>
                <div id='features' style={{backgroundColor: "#321d05", textAlign: "center", paddingBottom: "5%"}}>
                    <h1 style={{color: "white", fontFamily: "sora", paddingTop: "7.5%", fontSize: "84.5px"}}>Features</h1>
                    <div>
                        <h1 style={{fontSize: "37.5px", textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Make quick & easy modifications to your customer-facing web application as needed</h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawCampaignsVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{fontSize: "37.5px", textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Add customization to suit the language and look of your brand </h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawCampaigns2Video.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{fontSize: "37.5px", textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Create incentives for customers to spend by offering higher value earning on various purchases</h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawPolicyVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{fontSize: "37.5px", textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Create on-menu OR off-menu rewards for your customers in seconds</h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawRewardsVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{fontSize: "37.5px", textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Segment your customers for better targeted email marketing</h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/membersDemo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{fontSize: "37.5px", textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Track analytics for meals, rewards and customer spending all-year round</h1>
                        <div className='smallPhoneFeaturesBtn'>
                            <button 
                            onClick={this.bookCalendarEvent}
                            style={{fontSize: "30.5px"}}
                            >Schedule full product demo</button>
                        </div>
                    </div>
                </div>
                <div id='pricing' style={{textAlign: "center", marginBottom: "10%"}}>
                    <h1 style={{color: "#321d05", fontFamily: "sora", paddingTop: "2.5%", fontSize: "84.5px"}}>Pricing</h1>
                    <div className='priceTimeFrameSmallPhone'>
                        <button
                        onClick={this.monthlyPriceCardClicked}
                        style={{
                            fontSize: "27.5px",
                            backgroundColor: this.state.monthlyBgColor,
                            color: this.state.monthlyTxtColor,
                            borderTopLeftRadius: "8px",
                            borderBottomLeftRadius: "8px",
                            border: "1px solid #0930cb",
                            borderRight: "0px solid transparent"
                        }}
                        >Monthly</button>
                        <button
                        onClick={this.yearlyPriceCardClicked}
                        style={{
                            fontSize: "27.5px",
                            backgroundColor: this.state.yearlyBgColor,
                            color: this.state.yearlyTxtColor,
                            borderTopRightRadius: "8px",
                            borderBottomRightRadius: "8px",
                            border: "1px solid #0930cb"
                        }}
                        >Yearly</button>
                    </div>
                    <CSSTransition
                    in={this.state.showMonthlyPriceCard}
                    timeout={500}
                    classNames="dialog-slide"
                    unmountOnExit
                    >
                        <div>
                            {this.state.showMonthlyPriceCard && 
                                <div className='priceCardSmallPhone'>
                                    <h2 style={{fontSize: "57.5px"}}>Standard</h2>
                                    <h1 style={{fontSize: "100.5px"}}>15,000 Kshs<label style={{fontSize: "28.5px", marginLeft: "1%"}}>/ month</label></h1>
                                    <p style={{fontSize: "29px"}}>(per branch)</p>
                                    <div style={{marginTop: "8%"}}>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "28.5px", paddingTop: "1.5%"}}>Unlimited customer sign ups</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "28.5px", paddingTop: "1.5%"}}>Unlimited customer rewards</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "28.5px", paddingTop: "1.5%"}}>Unlimited feature access</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "28.5px", paddingTop: "1.5%"}}>White label branding</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "28.5px", paddingTop: "1.5%"}}>Personalized URL for your brand</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{marginTop: "6.5%"}}>
                                        <button
                                        style={{fontSize: "30px"}}
                                        onClick={this.bookCalendarEvent}
                                        >Get Started</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </CSSTransition>
                    <CSSTransition
                    in={this.state.showYearlyPriceCard}
                    timeout={500}
                    classNames="dialog-slide"
                    unmountOnExit
                    >
                        <div>
                            {this.state.showYearlyPriceCard && 
                                <div className='priceCardSmallPhone'>
                                    <h2 style={{fontSize: "57.5px"}}>Standard <label style={{fontSize: "28.5px", color: "red", fontFamily: "rubik", marginLeft: "2%"}}>(Save 33% annually)</label></h2>
                                    <h1 style={{fontSize: "100.5px"}}>10,000 Kshs<label style={{fontSize: "28.5px", marginLeft: "1%"}}>/ month</label></h1>
                                    <p style={{fontSize: "29px"}}>(per branch)</p>
                                    <div style={{marginTop: "8%"}}>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "28.5px", paddingTop: "1.5%"}}>Unlimited customer sign ups</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "28.5px", paddingTop: "1.5%"}}>Unlimited customer rewards</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "28.5px", paddingTop: "1.5%"}}>Unlimited feature access</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "28.5px", paddingTop: "1.5%"}}>White label branding</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "28.5px", paddingTop: "1.5%"}}>Personalized URL for your brand</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{marginTop: "6.5%"}}>
                                        <button
                                        style={{fontSize: "30px"}}
                                        >Get Started</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </CSSTransition>
                </div>
                <div className='footerSmallPhone'>
                    <div className='footerCol1SmallPhone'>
                        <img src="/assets/paper-plane-logo.png"/>
                        <div className='footerSocial'>
                            {/* <img src='/assets/footer-linkedin.png'/> */}
                        </div>
                        {/* <label style={{marginLeft: "1.5%", color: "white", fontFamily: "sora"}}>kifaa</label> */}
                        {/* <p>© kifaa</p> */}
                    </div>
                    <div className='footerCol2SmallPhone'>
                        <h3 style={{fontSize: "43.5px"}}>Product</h3>
                        <p style={{fontSize: "35px"}}><label onClick={this.handleScrollToFeatures}>Features</label></p>
                        <p style={{fontSize: "35px"}}><label onClick={this.handleScrollToPricing}>Pricing</label></p>
                    </div>
                    <div className='footerCol3SmallPhone'>
                        <h3 style={{fontSize: "43.5px"}}>Contact</h3>  
                        <p style={{fontSize: "35px"}}><label><a href={`tel:${phoneNumber}`}>{phoneNumber}</a></label></p> 
                    </div>
                    <div className='footerCol4'>
                        {/* <h3>Legal</h3>  
                        <p><label>Terms of use</label></p> 
                        <p><label>Privacy policy</label></p>  */}
                    </div>
                </div>
            </div>
        )
    }

    renderLargestTabletView = () => {
        let phoneNumber = "+254717230621"
        return (
            <div>
                <div>
                    <Container>
                        <div style={{display: "flex", justifyContent:"space-between"}}>
                            <h2 style={{paddingLeft: "4%", fontWeight: "bold", paddingTop: "2%", color: "#000", fontSize: "46.5px"}}>kifaa</h2>
                            {/* <div className='navbarContainer'>
                                <img src='/assets/paper-plane-logo.png'/>
                            </div> */}
                            <Button onClick={this.toggleDropdown}>
                                <img style={{width: "30px", height: "30px"}} className='menu-btn' src='/assets/smallPhoneHomeMenu.png'/>
                            </Button>
                        </div>
                        <CSSTransition
                            in={this.state.isDropdownOpen}
                            timeout={500}
                            classNames="dialog-slide2"
                            unmountOnExit
                            >
                            <Dropdown style={{width: "98%"}} className='dropdown' open={this.state.isDropdownOpen}>
                            {/* <p onClick={this.logout} style={{paddingRight: "2.5%"}}>Logout</p> */}
                            <p onClick={this.handleScrollToFeatures} style={{paddingRight: "2.5%", fontSize: "30.5px"}}> Features</p>
                            <p onClick={this.handleScrollToPricing} style={{paddingRight: "2.5%", fontSize: "30.5px"}}>Pricing</p>
                            {/* <p onClick={this.dropdownOption4Clicked} style={{paddingRight: "2.5%"}}>Challenges</p> */}
                            </Dropdown>
                        </CSSTransition>
                    </Container>
                    <h1 style={{color: "#321d05", marginLeft: "4%", marginRight: "4%", fontSize: "86.5px"}}>
                        <span><u><Typewriter options={{
                        strings: ["elevate your brand w/", 'worthwhile', "personalised", "easy to setup"],
                        autoStart: true,
                        loop: true,
                        }}
                        /></u></span><label style={{color: "#000"}}>rewards for your best customers </label>
                    </h1>
                </div>
                <div style={{paddingBottom: "5%"}} className='smallPhoneVideo'>
                    <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        className='pageVideo'
                    >
                        <source src='/assets/customerBackgroundRight3.5.mp4' type='video/mp4' />
                        {/* You can add additional source elements for different video formats */}
                        Your browser does not support the video tag.
                    </video>
                </div>
                <div id='features' style={{backgroundColor: "#321d05", textAlign: "center", paddingBottom: "5%"}}>
                    <h1 style={{color: "white", fontFamily: "sora", paddingTop: "7.5%", fontSize: "94.5px"}}>Features</h1>
                    <div>
                        <h1 style={{fontSize: "42.5px", textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Make quick & easy modifications to your customer-facing web application as needed</h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawCampaignsVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{fontSize: "42.5px", textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Add customization to suit the language and look of your brand </h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawCampaigns2Video.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{fontSize: "42.5px", textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Create incentives for customers to spend by offering higher value earning on various purchases</h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawPolicyVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{fontSize: "42.5px", textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Create on-menu OR off-menu rewards for your customers in seconds</h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawRewardsVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{fontSize: "42.5px", textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Segment your customers for better targeted email marketing</h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/membersDemo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{fontSize: "42.5px", textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Track analytics for meals, rewards and customer spending all-year round</h1>
                        <div className='smallPhoneFeaturesBtn'>
                            <button 
                            onClick={this.bookCalendarEvent}
                            style={{fontSize: "37.5px"}}
                            >Schedule full product demo</button>
                        </div>
                    </div>
                </div>
                <div id='pricing' style={{textAlign: "center", marginBottom: "10%"}}>
                    <h1 style={{color: "#321d05", fontFamily: "sora", paddingTop: "2.5%", fontSize: "94.5px"}}>Pricing</h1>
                    <div className='priceTimeFrameSmallPhone'>
                        <button
                        onClick={this.monthlyPriceCardClicked}
                        style={{
                            fontSize: "30.5px",
                            backgroundColor: this.state.monthlyBgColor,
                            color: this.state.monthlyTxtColor,
                            borderTopLeftRadius: "8px",
                            borderBottomLeftRadius: "8px",
                            border: "1px solid #0930cb",
                            borderRight: "0px solid transparent"
                        }}
                        >Monthly</button>
                        <button
                        onClick={this.yearlyPriceCardClicked}
                        style={{
                            fontSize: "30.5px",
                            backgroundColor: this.state.yearlyBgColor,
                            color: this.state.yearlyTxtColor,
                            borderTopRightRadius: "8px",
                            borderBottomRightRadius: "8px",
                            border: "1px solid #0930cb"
                        }}
                        >Yearly</button>
                    </div>
                    <CSSTransition
                    in={this.state.showMonthlyPriceCard}
                    timeout={500}
                    classNames="dialog-slide"
                    unmountOnExit
                    >
                        <div>
                            {this.state.showMonthlyPriceCard && 
                                <div className='priceCardSmallPhone'>
                                    <h2 style={{fontSize: "61.5px"}}>Standard</h2>
                                    <h1 style={{fontSize: "115.5px"}}>15,000 Kshs<label style={{fontSize: "30.5px", marginLeft: "1%"}}>/ month</label></h1>
                                    <p style={{fontSize: "31px"}}>(per branch)</p>
                                    <div style={{marginTop: "8%"}}>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "30.5px", paddingTop: "1.5%"}}>Unlimited customer sign ups</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "30.5px", paddingTop: "1.5%"}}>Unlimited customer rewards</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "30.5px", paddingTop: "1.5%"}}>Unlimited feature access</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "30.5px", paddingTop: "1.5%"}}>White label branding</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "30.5px", paddingTop: "1.5%"}}>Personalized URL for your brand</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{marginTop: "6.5%"}}>
                                        <button
                                        style={{fontSize: "34px"}}
                                        onClick={this.bookCalendarEvent}
                                        >Get Started</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </CSSTransition>
                    <CSSTransition
                    in={this.state.showYearlyPriceCard}
                    timeout={500}
                    classNames="dialog-slide"
                    unmountOnExit
                    >
                        <div>
                            {this.state.showYearlyPriceCard && 
                                <div className='priceCardSmallPhone'>
                                    <h2 style={{fontSize: "61.5px"}}>Standard <label style={{fontSize: "30.5px", color: "red", fontFamily: "rubik", marginLeft: "2%"}}>(Save 33% annually)</label></h2>
                                    <h1 style={{fontSize: "115.5px"}}>10,000 Kshs<label style={{fontSize: "30.5px", marginLeft: "1%"}}>/ month</label></h1>
                                    <p style={{fontSize: "31px"}}>(per branch)</p>
                                    <div style={{marginTop: "8%"}}>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "30.5px", paddingTop: "1.5%"}}>Unlimited customer sign ups</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "30.5px", paddingTop: "1.5%"}}>Unlimited customer rewards</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "30.5px", paddingTop: "1.5%"}}>Unlimited feature access</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "30.5px", paddingTop: "1.5%"}}>White label branding</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "30.5px", paddingTop: "1.5%"}}>Personalized URL for your brand</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{marginTop: "6.5%"}}>
                                        <button
                                        style={{fontSize: "34px"}}
                                        >Get Started</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </CSSTransition>
                </div>
                <div className='footerSmallPhone'>
                    <div className='footerCol1SmallPhone'>
                        <img src="/assets/paper-plane-logo.png"/>
                        <div className='footerSocial'>
                            {/* <img src='/assets/footer-linkedin.png'/> */}
                        </div>
                        {/* <label style={{marginLeft: "1.5%", color: "white", fontFamily: "sora"}}>kifaa</label> */}
                        {/* <p>© kifaa</p> */}
                    </div>
                    <div className='footerCol2SmallPhone'>
                        <h3 style={{fontSize: "43.5px"}}>Product</h3>
                        <p style={{fontSize: "35px"}}><label onClick={this.handleScrollToFeatures}>Features</label></p>
                        <p style={{fontSize: "35px"}}><label onClick={this.handleScrollToPricing}>Pricing</label></p>
                    </div>
                    <div className='footerCol3SmallPhone'>
                        <h3 style={{fontSize: "43.5px"}}>Contact</h3>  
                        <p style={{fontSize: "35px"}}><label><a href={`tel:${phoneNumber}`}>{phoneNumber}</a></label></p> 
                    </div>
                    <div className='footerCol4'>
                        {/* <h3>Legal</h3>  
                        <p><label>Terms of use</label></p> 
                        <p><label>Privacy policy</label></p>  */}
                    </div>
                </div>
            </div>
        )
    }

        //* - - PHABLET VIEWS - - *//

    renderPhabletView = () => {
        let phoneNumber = "+254717230621"
        return (
            <div>
                <div>
                    <Container>
                        <div style={{display: "flex", justifyContent:"space-between"}}>
                            <h2 style={{paddingLeft: "4%", fontWeight: "bold", paddingTop: "2%", color: "#000"}}>kifaa</h2>
                            {/* <div className='navbarContainer'>
                                <img src='/assets/paper-plane-logo.png'/>
                            </div> */}
                            <Button onClick={this.toggleDropdown}>
                                <img className='menu-btn' src='/assets/smallPhoneHomeMenu.png'/>
                            </Button>
                        </div>
                        <CSSTransition
                            in={this.state.isDropdownOpen}
                            timeout={500}
                            classNames="dialog-slide2"
                            unmountOnExit
                            >
                            <Dropdown className='dropdown' open={this.state.isDropdownOpen}>
                            {/* <p onClick={this.logout} style={{paddingRight: "2.5%"}}>Logout</p> */}
                            <p onClick={this.handleScrollToFeatures} style={{paddingRight: "2.5%"}}> Features</p>
                            <p onClick={this.handleScrollToPricing} style={{paddingRight: "2.5%"}}>Pricing</p>
                            {/* <p onClick={this.dropdownOption4Clicked} style={{paddingRight: "2.5%"}}>Challenges</p> */}
                            </Dropdown>
                        </CSSTransition>
                    </Container>
                    <h1 style={{color: "#321d05", marginLeft: "4%", marginRight: "4%", fontSize: "37.5px"}}>
                        <span><u><Typewriter options={{
                        strings: ["elevate your brand w/", 'worthwhile', "personalised", "easy to setup"],
                        autoStart: true,
                        loop: true,
                        }}
                        /></u></span><label style={{color: "#000"}}>rewards for your best customers </label>
                    </h1>
                </div>
                <div style={{paddingBottom: "5%"}} className='smallPhoneVideo'>
                    <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        className='pageVideo'
                    >
                        <source src='/assets/customerBackgroundRight3.5.mp4' type='video/mp4' />
                        {/* You can add additional source elements for different video formats */}
                        Your browser does not support the video tag.
                    </video>
                </div>
                <div id='features' style={{backgroundColor: "#321d05", textAlign: "center", paddingBottom: "5%"}}>
                    <h1 style={{color: "white", fontFamily: "sora", paddingTop: "7.5%", fontSize: "44px"}}>Features</h1>
                    <div>
                        <h3 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Make quick & easy modifications to your customer-facing web application as needed</h3>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawCampaignsVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h3 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Add customization to suit the language and look of your brand </h3>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawCampaigns2Video.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h3 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Create incentives for customers to spend by offering higher value earning on various purchases</h3>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawPolicyVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h3 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Create on-menu OR off-menu rewards for your customers in seconds</h3>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawRewardsVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h3 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Segment your customers for better targeted email marketing</h3>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/membersDemo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h3 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Track analytics for meals, rewards and customer spending all-year round</h3>
                        <div className='smallPhoneFeaturesBtn'>
                            <button
                            onClick={this.bookCalendarEvent}
                            >Schedule full product demo</button>
                        </div>
                    </div>
                </div>
                <div id='pricing' style={{textAlign: "center", marginBottom: "10%"}}>
                    <h1 style={{color: "#321d05", fontFamily: "sora", paddingTop: "5%", fontSize: "44px"}}>Pricing</h1>
                    <div className='priceTimeFrameSmallPhone'>
                        <button
                        onClick={this.monthlyPriceCardClicked}
                        style={{
                            backgroundColor: this.state.monthlyBgColor,
                            color: this.state.monthlyTxtColor,
                            borderTopLeftRadius: "8px",
                            borderBottomLeftRadius: "8px",
                            border: "1px solid #0930cb",
                            borderRight: "0px solid transparent"
                        }}
                        >Monthly</button>
                        <button
                        onClick={this.yearlyPriceCardClicked}
                        style={{
                            backgroundColor: this.state.yearlyBgColor,
                            color: this.state.yearlyTxtColor,
                            borderTopRightRadius: "8px",
                            borderBottomRightRadius: "8px",
                            border: "1px solid #0930cb"
                        }}
                        >Yearly</button>
                    </div>
                    <CSSTransition
                    in={this.state.showMonthlyPriceCard}
                    timeout={500}
                    classNames="dialog-slide"
                    unmountOnExit
                    >
                        <div>
                            {this.state.showMonthlyPriceCard && 
                                <div className='priceCardSmallPhone'>
                                    <h2 style={{fontSize: "27.5px"}}>Standard</h2>
                                    <h1 style={{fontSize: "47.5px"}}>15,000 Kshs<label style={{fontSize: "17px", marginLeft: "1%"}}>/ month</label></h1>
                                    <p>(per branch)</p>
                                    <div style={{marginTop: "8%"}}>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "80%", paddingTop: "1.25%"}}>Unlimited customer sign ups</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "80%", paddingTop: "1.25%"}}>Unlimited customer rewards</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "80%", paddingTop: "1.25%"}}>Unlimited feature access</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "80%", paddingTop: "1.25%"}}>White label branding</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "80%", paddingTop: "1.25%"}}>Personalized URL for your brand</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{marginTop: "6.5%"}}>
                                        <button
                                        onClick={this.bookCalendarEvent}
                                        >Get Started</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </CSSTransition>
                    <CSSTransition
                    in={this.state.showYearlyPriceCard}
                    timeout={500}
                    classNames="dialog-slide"
                    unmountOnExit
                    >
                        <div>
                            {this.state.showYearlyPriceCard && 
                                <div className='priceCardSmallPhone'>
                                    <h2 style={{fontSize: "27.5px"}}>Standard <label style={{fontSize: "16.5px", color: "red", fontFamily: "rubik", marginLeft: "2%"}}>(Save 33% annually)</label></h2>
                                    <h1 style={{fontSize: "47.5px"}}>10,000 Kshs<label style={{fontSize: "14px", marginLeft: "1%"}}>/ month</label></h1>
                                    <p>(per branch)</p>
                                    <div style={{marginTop: "8%"}}>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "80%", paddingTop: "1.25%"}}>Unlimited customer sign ups</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "80%", paddingTop: "1.25%"}}>Unlimited customer rewards</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "80%", paddingTop: "1.25%"}}>Unlimited feature access</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "80%", paddingTop: "1.25%"}}>White label branding</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "80%", paddingTop: "1.25%"}}>Personalized URL for your brand</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{marginTop: "6.5%"}}>
                                        <button
                                        >Get Started</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </CSSTransition>
                </div>
                <div className='footerSmallPhone'>
                    <div className='footerCol1SmallPhone'>
                        <img src="/assets/paper-plane-logo.png"/>
                        <div className='footerSocial'>
                            {/* <img src='/assets/footer-linkedin.png'/> */}
                        </div>
                        {/* <label style={{marginLeft: "1.5%", color: "white", fontFamily: "sora"}}>kifaa</label> */}
                        {/* <p>© kifaa</p> */}
                    </div>
                    <div className='footerCol2SmallPhone'>
                        <h3>Product</h3>
                        <p><label onClick={this.handleScrollToFeatures}>Features</label></p>
                        <p><label onClick={this.handleScrollToPricing}>Pricing</label></p>
                    </div>
                    <div className='footerCol3SmallPhone'>
                        <h3>Contact</h3>  
                        <p><label><a href={`tel:${phoneNumber}`}>{phoneNumber}</a></label></p> 
                    </div>
                    <div className='footerCol4'>
                        {/* <h3>Legal</h3>  
                        <p><label>Terms of use</label></p> 
                        <p><label>Privacy policy</label></p>  */}
                    </div>
                </div>
            </div>
        )
    }

    renderLargePhabletView = () => {
        let phoneNumber = "+254717230621"
        return (
            <div>
                <div>
                    <Container>
                        <div style={{display: "flex", justifyContent:"space-between"}}>
                            <h2 style={{paddingLeft: "4%", fontWeight: "bold", paddingTop: "2%", color: "#000", fontSize: "27.5px"}}>kifaa</h2>
                            {/* <div className='navbarContainer'>
                                <img src='/assets/paper-plane-logo.png'/>
                            </div> */}
                            <Button onClick={this.toggleDropdown}>
                                <img className='menu-btn' src='/assets/smallPhoneHomeMenu.png'/>
                            </Button>
                        </div>
                        <CSSTransition
                            in={this.state.isDropdownOpen}
                            timeout={500}
                            classNames="dialog-slide2"
                            unmountOnExit
                            >
                            <Dropdown className='dropdown' open={this.state.isDropdownOpen}>
                            {/* <p onClick={this.logout} style={{paddingRight: "2.5%"}}>Logout</p> */}
                            <p onClick={this.handleScrollToFeatures} style={{paddingRight: "2.5%", fontSize: "17.5px"}}> Features</p>
                            <p onClick={this.handleScrollToPricing} style={{paddingRight: "2.5%", fontSize: "17.5px"}}>Pricing</p>
                            {/* <p onClick={this.dropdownOption4Clicked} style={{paddingRight: "2.5%"}}>Challenges</p> */}
                            </Dropdown>
                        </CSSTransition>
                    </Container>
                    <h1 style={{color: "#321d05", marginLeft: "4%", marginRight: "4%", fontSize: "46px"}}>
                        <span><u><Typewriter options={{
                        strings: ["elevate your brand w/", 'worthwhile', "personalised", "easy to setup"],
                        autoStart: true,
                        loop: true,
                        }}
                        /></u></span><label style={{color: "#000"}}>rewards for your best customers </label>
                    </h1>
                </div>
                <div style={{paddingBottom: "5%"}} className='smallPhoneVideo'>
                    <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        className='pageVideo'
                    >
                        <source src='/assets/customerBackgroundRight3.5.mp4' type='video/mp4' />
                        {/* You can add additional source elements for different video formats */}
                        Your browser does not support the video tag.
                    </video>
                </div>
                <div id='features' style={{backgroundColor: "#321d05", textAlign: "center", paddingBottom: "5%"}}>
                    <h1 style={{color: "white", fontFamily: "sora", paddingTop: "7.5%", fontSize: "52.5px"}}>Features</h1>
                    <div>
                        <h2 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Make quick & easy modifications to your customer-facing web application as needed</h2>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawCampaignsVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h2 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Add customization to suit the language and look of your brand </h2>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawCampaigns2Video.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h2 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Create incentives for customers to spend by offering higher value earning on various purchases</h2>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawPolicyVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h2 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Create on-menu OR off-menu rewards for your customers in seconds</h2>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawRewardsVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h2 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Segment your customers for better targeted email marketing</h2>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/membersDemo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h2 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Track analytics for meals, rewards and customer spending all-year round</h2>
                        <div className='smallPhoneFeaturesBtn'>
                            <button 
                            onClick={this.bookCalendarEvent}
                            style={{fontSize: "18px"}}
                            >Schedule full product demo</button>
                        </div>
                    </div>
                </div>
                <div id='pricing' style={{textAlign: "center", marginBottom: "10%"}}>
                    <h1 style={{color: "#321d05", fontFamily: "sora", paddingTop: "7.5%", fontSize: "52.5px"}}>Pricing</h1>
                    <div className='priceTimeFrameSmallPhone'>
                        <button
                        onClick={this.monthlyPriceCardClicked}
                        style={{
                            backgroundColor: this.state.monthlyBgColor,
                            color: this.state.monthlyTxtColor,
                            borderTopLeftRadius: "8px",
                            borderBottomLeftRadius: "8px",
                            border: "1px solid #0930cb",
                            borderRight: "0px solid transparent",
                            fontSize: "16px"
                        }}
                        >Monthly</button>
                        <button
                        onClick={this.yearlyPriceCardClicked}
                        style={{
                            backgroundColor: this.state.yearlyBgColor,
                            color: this.state.yearlyTxtColor,
                            borderTopRightRadius: "8px",
                            borderBottomRightRadius: "8px",
                            border: "1px solid #0930cb",
                            fontSize: "16px"
                        }}
                        >Yearly</button>
                    </div>
                    <CSSTransition
                    in={this.state.showMonthlyPriceCard}
                    timeout={500}
                    classNames="dialog-slide"
                    unmountOnExit
                    >
                        <div>
                            {this.state.showMonthlyPriceCard && 
                                <div className='priceCardSmallPhone'>
                                    <h2 style={{fontSize: "32px"}}>Standard</h2>
                                    <h1 style={{fontSize: "59.5px"}}>15,000 Kshs<label style={{fontSize: "17px", marginLeft: "1%"}}>/ month</label></h1>
                                    <p>(per branch)</p>
                                    <div style={{marginTop: "8%"}}>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "95%", paddingTop: "1.5%"}}>Unlimited customer sign ups</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "95%", paddingTop: "1.5%"}}>Unlimited customer rewards</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "95%", paddingTop: "1.5%"}}>Unlimited feature access</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "95%", paddingTop: "1.5%"}}>White label branding</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "95%", paddingTop: "1.5%"}}>Personalized URL for your brand</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{marginTop: "6.5%"}}>
                                        <button
                                        style={{fontSize: "18px"}}
                                        onClick={this.bookCalendarEvent}
                                        >Get Started</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </CSSTransition>
                    <CSSTransition
                    in={this.state.showYearlyPriceCard}
                    timeout={500}
                    classNames="dialog-slide"
                    unmountOnExit
                    >
                        <div>
                            {this.state.showYearlyPriceCard && 
                                <div className='priceCardSmallPhone'>
                                    <h2 style={{fontSize: "32px"}}>Standard <label style={{fontSize: "16.5px", color: "red", fontFamily: "rubik", marginLeft: "2%"}}>(Save 33% annually)</label></h2>
                                    <h1 style={{fontSize: "59.5px"}}>10,000 Kshs<label style={{fontSize: "14px", marginLeft: "1%"}}>/ month</label></h1>
                                    <p>(per branch)</p>
                                    <div style={{marginTop: "8%"}}>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "95%", paddingTop: "1.5%"}}>Unlimited customer sign ups</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "95%", paddingTop: "1.5%"}}>Unlimited customer rewards</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "95%", paddingTop: "1.5%"}}>Unlimited feature access</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "95%", paddingTop: "1.5%"}}>White label branding</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "95%", paddingTop: "1.5%"}}>Personalized URL for your brand</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{marginTop: "6.5%"}}>
                                        <button
                                        style={{fontSize: "18px"}}
                                        >Get Started</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </CSSTransition>
                </div>
                <div className='footerSmallPhone'>
                    <div className='footerCol1SmallPhone'>
                        <img src="/assets/paper-plane-logo.png"/>
                        <div className='footerSocial'>
                            {/* <img src='/assets/footer-linkedin.png'/> */}
                        </div>
                        {/* <label style={{marginLeft: "1.5%", color: "white", fontFamily: "sora"}}>kifaa</label> */}
                        {/* <p>© kifaa</p> */}
                    </div>
                    <div className='footerCol2SmallPhone'>
                        <h3 style={{fontSize: "22px"}}>Product</h3>
                        <p style={{fontSize: "19.5px"}}><label onClick={this.handleScrollToFeatures}>Features</label></p>
                        <p style={{fontSize: "19.5px"}}><label onClick={this.handleScrollToPricing}>Pricing</label></p>
                    </div>
                    <div className='footerCol3SmallPhone'>
                        <h3 style={{fontSize: "22px"}}>Contact</h3>  
                        <p style={{fontSize: "19.5px"}}><label><a href={`tel:${phoneNumber}`}>{phoneNumber}</a></label></p> 
                    </div>
                    <div className='footerCol4'>
                        {/* <h3>Legal</h3>  
                        <p><label>Terms of use</label></p> 
                        <p><label>Privacy policy</label></p>  */}
                    </div>
                </div>
            </div>
        )
    }

    renderLargestPhabletView = () => {
        let phoneNumber = "+254717230621"
        return (
            <div>
                <div>
                    <Container>
                        <div style={{display: "flex", justifyContent:"space-between"}}>
                            <h2 style={{paddingLeft: "4%", fontWeight: "bold", paddingTop: "2%", color: "#000", fontSize: "30.5px"}}>kifaa</h2>
                            {/* <div className='navbarContainer'>
                                <img src='/assets/paper-plane-logo.png'/>
                            </div> */}
                            <Button onClick={this.toggleDropdown}>
                                <img className='menu-btn' src='/assets/smallPhoneHomeMenu.png'/>
                            </Button>
                        </div>
                        <CSSTransition
                            in={this.state.isDropdownOpen}
                            timeout={500}
                            classNames="dialog-slide2"
                            unmountOnExit
                            >
                            <Dropdown style={{width: "97%"}} className='dropdown' open={this.state.isDropdownOpen}>
                            {/* <p onClick={this.logout} style={{paddingRight: "2.5%"}}>Logout</p> */}
                            <p onClick={this.handleScrollToFeatures} style={{paddingRight: "2.5%", fontSize: "20px"}}> Features</p>
                            <p onClick={this.handleScrollToPricing} style={{paddingRight: "2.5%", fontSize: "20px"}}>Pricing</p>
                            {/* <p onClick={this.dropdownOption4Clicked} style={{paddingRight: "2.5%"}}>Challenges</p> */}
                            </Dropdown>
                        </CSSTransition>
                    </Container>
                    <h1 style={{color: "#321d05", marginLeft: "4%", marginRight: "4%", fontSize: "52px"}}>
                        <span><u><Typewriter options={{
                        strings: ["elevate your brand w/", 'worthwhile', "personalised", "easy to setup"],
                        autoStart: true,
                        loop: true,
                        }}
                        /></u></span><label style={{color: "#000"}}>rewards for your best customers </label>
                    </h1>
                </div>
                <div style={{paddingBottom: "5%"}} className='smallPhoneVideo'>
                    <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        className='pageVideo'
                    >
                        <source src='/assets/customerBackgroundRight3.5.mp4' type='video/mp4' />
                        {/* You can add additional source elements for different video formats */}
                        Your browser does not support the video tag.
                    </video>
                </div>
                <div id='features' style={{backgroundColor: "#321d05", textAlign: "center", paddingBottom: "5%"}}>
                    <h1 style={{color: "white", fontFamily: "sora", paddingTop: "7.5%", fontSize: "60.5px"}}>Features</h1>
                    <div>
                        <h1 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Make quick & easy modifications to your customer-facing web application as needed</h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawCampaignsVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Add customization to suit the language and look of your brand </h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawCampaigns2Video.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Create incentives for customers to spend by offering higher value earning on various purchases</h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawPolicyVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Create on-menu OR off-menu rewards for your customers in seconds</h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawRewardsVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Segment your customers for better targeted email marketing</h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/membersDemo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Track analytics for meals, rewards and customer spending all-year round</h1>
                        <div className='smallPhoneFeaturesBtn'>
                            <button 
                            onClick={this.bookCalendarEvent}
                            style={{fontSize: "19px"}}
                            >Schedule full product demo</button>
                        </div>
                    </div>
                </div>
                <div id='pricing' style={{textAlign: "center", marginBottom: "10%"}}>
                    <h1 style={{color: "#0930cb", fontFamily: "sora", paddingTop: "2.5%", fontSize: "60.5px"}}>Pricing</h1>
                    <div className='priceTimeFrameSmallPhone'>
                        <button
                        onClick={this.monthlyPriceCardClicked}
                        style={{
                            fontSize: "18px",
                            backgroundColor: this.state.monthlyBgColor,
                            color: this.state.monthlyTxtColor,
                            borderTopLeftRadius: "8px",
                            borderBottomLeftRadius: "8px",
                            border: "1px solid #0930cb",
                            borderRight: "0px solid transparent"
                        }}
                        >Monthly</button>
                        <button
                        onClick={this.yearlyPriceCardClicked}
                        style={{
                            fontSize: "18px",
                            backgroundColor: this.state.yearlyBgColor,
                            color: this.state.yearlyTxtColor,
                            borderTopRightRadius: "8px",
                            borderBottomRightRadius: "8px",
                            border: "1px solid #0930cb"
                        }}
                        >Yearly</button>
                    </div>
                    <CSSTransition
                    in={this.state.showMonthlyPriceCard}
                    timeout={500}
                    classNames="dialog-slide"
                    unmountOnExit
                    >
                        <div>
                            {this.state.showMonthlyPriceCard && 
                                <div className='priceCardSmallPhone'>
                                    <h2 style={{fontSize: "35px"}}>Standard</h2>
                                    <h1 style={{fontSize: "65.5px"}}>15,000 Kshs<label style={{fontSize: "18px", marginLeft: "1%"}}>/ month</label></h1>
                                    <p>(per branch)</p>
                                    <div style={{marginTop: "8%"}}>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "95%", paddingTop: "1.75%"}}>Unlimited customer sign ups</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "95%", paddingTop: "1.75%"}}>Unlimited customer rewards</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "95%", paddingTop: "1.75%"}}>Unlimited feature access</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "95%", paddingTop: "1.75%"}}>White label branding</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "95%", paddingTop: "1.75%"}}>Personalized URL for your brand</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{marginTop: "6.5%"}}>
                                        <button
                                        style={{fontSize: "19px"}}
                                        onClick={this.bookCalendarEvent}
                                        >Get Started</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </CSSTransition>
                    <CSSTransition
                    in={this.state.showYearlyPriceCard}
                    timeout={500}
                    classNames="dialog-slide"
                    unmountOnExit
                    >
                        <div>
                            {this.state.showYearlyPriceCard && 
                                <div className='priceCardSmallPhone'>
                                    <h2 style={{fontSize: "35px"}}>Standard <label style={{fontSize: "19.5px", color: "red", fontFamily: "rubik", marginLeft: "2%"}}>(Save 33% annually)</label></h2>
                                    <h1 style={{fontSize: "65.5px"}}>10,000 Kshs<label style={{fontSize: "18px", marginLeft: "1%"}}>/ month</label></h1>
                                    <p>(per branch)</p>
                                    <div style={{marginTop: "8%"}}>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "95%", paddingTop: "1.75%"}}>Unlimited customer sign ups</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "95%", paddingTop: "1.75%"}}>Unlimited customer rewards</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "95%", paddingTop: "1.75%"}}>Unlimited feature access</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "95%", paddingTop: "1.75%"}}>White label branding</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "95%", paddingTop: "1.75%"}}>Personalized URL for your brand</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{marginTop: "6.5%"}}>
                                        <button
                                        style={{fontSize: "19px"}}
                                        >Get Started</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </CSSTransition>
                </div>
                <div className='footerSmallPhone'>
                    <div className='footerCol1SmallPhone'>
                        <img src="/assets/paper-plane-logo.png"/>
                        <div className='footerSocial'>
                            {/* <img src='/assets/footer-linkedin.png'/> */}
                        </div>
                        {/* <label style={{marginLeft: "1.5%", color: "white", fontFamily: "sora"}}>kifaa</label> */}
                        {/* <p>© kifaa</p> */}
                    </div>
                    <div className='footerCol2SmallPhone'>
                        <h3 style={{fontSize: "25px"}}>Product</h3>
                        <p style={{fontSize: "21px"}}><label onClick={this.handleScrollToFeatures}>Features</label></p>
                        <p style={{fontSize: "21px"}}><label onClick={this.handleScrollToPricing}>Pricing</label></p>
                    </div>
                    <div className='footerCol3SmallPhone'>
                        <h3 style={{fontSize: "25px"}}>Contact</h3>  
                        <p style={{fontSize: "21px"}}><label><a href={`tel:${phoneNumber}`}>{phoneNumber}</a></label></p> 
                    </div>
                    <div className='footerCol4'>
                        {/* <h3>Legal</h3>  
                        <p><label>Terms of use</label></p> 
                        <p><label>Privacy policy</label></p>  */}
                    </div>
                </div>
            </div>
        )
    }

    renderFinalPhabletMediaQuery = () => {
        let phoneNumber = "+254717230621"
        return (
            <div>
                <div>
                    <Container>
                        <div style={{display: "flex", justifyContent:"space-between"}}>
                            <h2 style={{paddingLeft: "4%", fontWeight: "bold", paddingTop: "2%", color: "#000", fontSize: "35px"}}>kifaa</h2>
                            {/* <div className='navbarContainer'>
                                <img src='/assets/paper-plane-logo.png'/>
                            </div> */}
                            <Button onClick={this.toggleDropdown}>
                                <img className='menu-btn' src='/assets/smallPhoneHomeMenu.png'/>
                            </Button>
                        </div>
                        <CSSTransition
                            in={this.state.isDropdownOpen}
                            timeout={500}
                            classNames="dialog-slide2"
                            unmountOnExit
                            >
                            <Dropdown style={{width: "98%"}} className='dropdown' open={this.state.isDropdownOpen}>
                            {/* <p onClick={this.logout} style={{paddingRight: "2.5%"}}>Logout</p> */}
                            <p onClick={this.handleScrollToFeatures} style={{paddingRight: "2.5%", fontSize: "20px"}}> Features</p>
                            <p onClick={this.handleScrollToPricing} style={{paddingRight: "2.5%", fontSize: "20px"}}>Pricing</p>
                            {/* <p onClick={this.dropdownOption4Clicked} style={{paddingRight: "2.5%"}}>Challenges</p> */}
                            </Dropdown>
                        </CSSTransition>
                    </Container>
                    <h1 style={{color: "#321d05", marginLeft: "4%", marginRight: "4%", fontSize: "60px"}}>
                        <span><u><Typewriter options={{
                        strings: ["elevate your brand w/", 'worthwhile', "personalised", "easy to setup"],
                        autoStart: true,
                        loop: true,
                        }}
                        /></u></span><label style={{color: "#000"}}>rewards for your best customers </label>
                    </h1>
                </div>
                <div style={{paddingBottom: "5%"}} className='smallPhoneVideo'>
                    <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        className='pageVideo'
                    >
                        <source src='/assets/customerBackgroundRight3.5.mp4' type='video/mp4' />
                        {/* You can add additional source elements for different video formats */}
                        Your browser does not support the video tag.
                    </video>
                </div>
                <div id='features' style={{backgroundColor: "#321d05", textAlign: "center", paddingBottom: "5%"}}>
                    <h1 style={{color: "white", fontFamily: "sora", paddingTop: "7.5%", fontSize: "66.5px"}}>Features</h1>
                    <div>
                        <h1 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Make quick & easy modifications to your customer-facing web application as needed</h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawCampaignsVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Add customization to suit the language and look of your brand </h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawCampaigns2Video.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Create incentives for customers to spend by offering higher value earning on various purchases</h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawPolicyVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Create on-menu OR off-menu rewards for your customers in seconds</h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawRewardsVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Segment your customers for better targeted email marketing</h1>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/membersDemo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h1 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Track analytics for meals, rewards and customer spending all-year round</h1>
                        <div className='smallPhoneFeaturesBtn'>
                            <button 
                            onClick={this.bookCalendarEvent}
                            style={{fontSize: "21px"}}
                            >Schedule full product demo</button>
                        </div>
                    </div>
                </div>
                <div id='pricing' style={{textAlign: "center", marginBottom: "10%"}}>
                    <h1 style={{color: "#321d05", fontFamily: "sora", paddingTop: "2.5%", fontSize: "66.5px"}}>Pricing</h1>
                    <div className='priceTimeFrameSmallPhone'>
                        <button
                        onClick={this.monthlyPriceCardClicked}
                        style={{
                            fontSize: "18px",
                            backgroundColor: this.state.monthlyBgColor,
                            color: this.state.monthlyTxtColor,
                            borderTopLeftRadius: "8px",
                            borderBottomLeftRadius: "8px",
                            border: "1px solid #0930cb",
                            borderRight: "0px solid transparent"
                        }}
                        >Monthly</button>
                        <button
                        onClick={this.yearlyPriceCardClicked}
                        style={{
                            fontSize: "18px",
                            backgroundColor: this.state.yearlyBgColor,
                            color: this.state.yearlyTxtColor,
                            borderTopRightRadius: "8px",
                            borderBottomRightRadius: "8px",
                            border: "1px solid #0930cb"
                        }}
                        >Yearly</button>
                    </div>
                    <CSSTransition
                    in={this.state.showMonthlyPriceCard}
                    timeout={500}
                    classNames="dialog-slide"
                    unmountOnExit
                    >
                        <div>
                            {this.state.showMonthlyPriceCard && 
                                <div className='priceCardSmallPhone'>
                                    <h2 style={{fontSize: "45px"}}>Standard</h2>
                                    <h1 style={{fontSize: "79.5px"}}>15,000 Kshs<label style={{fontSize: "19px", marginLeft: "1%"}}>/ month</label></h1>
                                    <p style={{fontSize: "20px"}}>(per branch)</p>
                                    <div style={{marginTop: "8%"}}>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "20px", paddingTop: "1.75%"}}>Unlimited customer sign ups</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "20px", paddingTop: "1.75%"}}>Unlimited customer rewards</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "20px", paddingTop: "1.75%"}}>Unlimited feature access</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "20px", paddingTop: "1.75%"}}>White label branding</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "20px", paddingTop: "1.75%"}}>Personalized URL for your brand</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{marginTop: "6.5%"}}>
                                        <button
                                        style={{fontSize: "21px"}}
                                        onClick={this.bookCalendarEvent}
                                        >Get Started</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </CSSTransition>
                    <CSSTransition
                    in={this.state.showYearlyPriceCard}
                    timeout={500}
                    classNames="dialog-slide"
                    unmountOnExit
                    >
                        <div>
                            {this.state.showYearlyPriceCard && 
                                <div className='priceCardSmallPhone'>
                                    <h2 style={{fontSize: "45px"}}>Standard <label style={{fontSize: "23.5px", color: "red", fontFamily: "rubik", marginLeft: "2%"}}>(Save 33% annually)</label></h2>
                                    <h1 style={{fontSize: "79.5px"}}>10,000 Kshs<label style={{fontSize: "19px", marginLeft: "1%"}}>/ month</label></h1>
                                    <p style={{fontSize: "20px"}}>(per branch)</p>
                                    <div style={{marginTop: "8%"}}>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "20px", paddingTop: "1.75%"}}>Unlimited customer sign ups</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "20px", paddingTop: "1.75%"}}>Unlimited customer rewards</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "20px", paddingTop: "1.75%"}}>Unlimited feature access</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "20px", paddingTop: "1.75%"}}>White label branding</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "20px", paddingTop: "1.75%"}}>Personalized URL for your brand</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{marginTop: "6.5%"}}>
                                        <button
                                        style={{fontSize: "21px"}}
                                        >Get Started</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </CSSTransition>
                </div>
                <div className='footerSmallPhone'>
                    <div className='footerCol1SmallPhone'>
                        <img src="/assets/paper-plane-logo.png"/>
                        <div className='footerSocial'>
                            {/* <img src='/assets/footer-linkedin.png'/> */}
                        </div>
                        {/* <label style={{marginLeft: "1.5%", color: "white", fontFamily: "sora"}}>kifaa</label> */}
                        {/* <p>© kifaa</p> */}
                    </div>
                    <div className='footerCol2SmallPhone'>
                        <h3 style={{fontSize: "33px"}}>Product</h3>
                        <p style={{fontSize: "26px"}}><label onClick={this.handleScrollToFeatures}>Features</label></p>
                        <p style={{fontSize: "26px"}}><label onClick={this.handleScrollToPricing}>Pricing</label></p>
                    </div>
                    <div className='footerCol3SmallPhone'>
                        <h3 style={{fontSize: "33px"}}>Contact</h3>  
                        <p style={{fontSize: "26px"}}><label><a href={`tel:${phoneNumber}`}>{phoneNumber}</a></label></p> 
                    </div>
                    <div className='footerCol4'>
                        {/* <h3>Legal</h3>  
                        <p><label>Terms of use</label></p> 
                        <p><label>Privacy policy</label></p>  */}
                    </div>
                </div>
            </div>
        )
    }

        //* - - SMARTPHONE VIEWS - - *//

    renderSmallPhoneView = () => {
        let phoneNumber = "+254717230621"
        return (
            <div>
                <div>
                    <Container>
                        <div style={{display: "flex", justifyContent:"space-between"}}>
                            <h2 style={{paddingLeft: "4%", fontWeight: "bold", paddingTop: "0%", color: "#000"}}>kifaa</h2>
                            {/* <div className='navbarContainer'>
                                <img src='/assets/paper-plane-logo.png'/>
                            </div> */}
                            <Button onClick={this.toggleDropdown}>
                                <img className='menu-btn' src='/assets/smallPhoneHomeMenu.png'/>
                            </Button>
                        </div>
                        <CSSTransition
                            in={this.state.isDropdownOpen}
                            timeout={500}
                            classNames="dialog-slide2"
                            unmountOnExit
                            >
                            <Dropdown className='dropdown' open={this.state.isDropdownOpen}>
                            {/* <p onClick={this.logout} style={{paddingRight: "2.5%"}}>Logout</p> */}
                            <p onClick={this.handleScrollToFeatures} style={{paddingRight: "2.5%"}}> Features</p>
                            <p onClick={this.handleScrollToPricing} style={{paddingRight: "2.5%"}}>Pricing</p>
                            {/* <p onClick={this.dropdownOption4Clicked} style={{paddingRight: "2.5%"}}>Challenges</p> */}
                            </Dropdown>
                        </CSSTransition>
                    </Container>
                    <h1 style={{color: "#321d05", marginLeft: "4%", marginRight: "4%"}}>
                        <span><u><Typewriter options={{
                        strings: ["elevate your brand w/", 'worthwhile', "personalised", "easy to setup"],
                        autoStart: true,
                        loop: true,
                        }}
                        /></u></span><label style={{color: "#000"}}>rewards for your best customers </label>
                    </h1>
                </div>
                <div style={{paddingBottom: "5%"}} className='smallPhoneVideo'>
                    <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        className='pageVideo'
                    >
                        <source src='/assets/customerBackgroundRight3.5.mp4' type='video/mp4' />
                        {/* You can add additional source elements for different video formats */}
                        Your browser does not support the video tag.
                    </video>
                </div>
                <div id='features' style={{backgroundColor: "#321d05", textAlign: "center", paddingBottom: "5%"}}>
                    <h1 style={{color: "white", fontFamily: "sora", paddingTop: "7.5%", fontSize: "35px"}}>Features</h1>
                    <div>
                        <h3 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Make quick & easy modifications to your customer-facing web application as needed</h3>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawCampaignsVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h3 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Add customization to suit the language and look of your brand </h3>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawCampaigns2Video.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h3 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Create incentives for customers to spend by offering higher value earning on various purchases</h3>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawPolicyVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h3 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Create on-menu OR off-menu rewards for your customers in seconds</h3>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/rawRewardsVideo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h3 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Segment your customers for better targeted email marketing</h3>
                    </div>
                    <div className='smallPhoneVideoDashboard'>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='pageVideo'
                        >
                            <source src='/assets/membersDemo.mp4' type='video/mp4' />
                            {/* You can add additional source elements for different video formats */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className='smallPhoneImg' style={{textAlign: "center"}}>
                        <img src='/assets/paper-plane-logo.png'/>
                    </div>
                    <div>
                        <h3 style={{textAlign: "left", marginLeft: "5%", marginRight: "5%", color: "white", marginBottom: "5%"}}>Track analytics for meals, rewards and customer spending all-year round</h3>
                        <div className='smallPhoneFeaturesBtn'>
                            <button
                            onClick={this.bookCalendarEvent}
                            >Schedule full product demo</button>
                        </div>
                    </div>
                </div>
                <div id='pricing' style={{textAlign: "center", marginBottom: "10%"}}>
                    <h1 style={{color: "#321d05", fontFamily: "sora", paddingTop: "7.5%", fontSize: "35px"}}>Pricing</h1>
                    <div className='priceTimeFrameSmallPhone'>
                        <button
                        onClick={this.monthlyPriceCardClicked}
                        style={{
                            backgroundColor: this.state.monthlyBgColor,
                            color: this.state.monthlyTxtColor,
                            borderTopLeftRadius: "8px",
                            borderBottomLeftRadius: "8px",
                            border: "1px solid #0930cb",
                            borderRight: "0px solid transparent"
                        }}
                        >Monthly</button>
                        <button
                        onClick={this.yearlyPriceCardClicked}
                        style={{
                            backgroundColor: this.state.yearlyBgColor,
                            color: this.state.yearlyTxtColor,
                            borderTopRightRadius: "8px",
                            borderBottomRightRadius: "8px",
                            border: "1px solid #0930cb"
                        }}
                        >Yearly</button>
                    </div>
                    <CSSTransition
                    in={this.state.showMonthlyPriceCard}
                    timeout={500}
                    classNames="dialog-slide"
                    unmountOnExit
                    >
                        <div>
                            {this.state.showMonthlyPriceCard && 
                                <div className='priceCardSmallPhone'>
                                    <h2>Standard</h2>
                                    <h1>15,000 Kshs<label style={{fontSize: "14px", marginLeft: "1%"}}>/ month</label></h1>
                                    <p>(per branch)</p>
                                    <div style={{marginTop: "8%"}}>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "80%", paddingTop: "0.75%"}}>Unlimited customer sign ups</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "80%", paddingTop: "0.75%"}}>Unlimited customer rewards</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "80%", paddingTop: "0.75%"}}>Unlimited feature access</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "80%", paddingTop: "0.75%"}}>White label branding</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "80%", paddingTop: "0.75%"}}>Personalized URL for your brand</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{marginTop: "6.5%"}}>
                                        <button
                                        onClick={this.bookCalendarEvent}
                                        >Get Started</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </CSSTransition>
                    <CSSTransition
                    in={this.state.showYearlyPriceCard}
                    timeout={500}
                    classNames="dialog-slide"
                    unmountOnExit
                    >
                        <div>
                            {this.state.showYearlyPriceCard && 
                                <div className='priceCardSmallPhone'>
                                    <h2>Standard <label style={{fontSize: "12.5px", color: "red", fontFamily: "rubik", marginLeft: "2%"}}>(Save 33% annually)</label></h2>
                                    <h1>10,000 Kshs<label style={{fontSize: "14px", marginLeft: "1%"}}>/ month</label></h1>
                                    <p>(per branch)</p>
                                    <div style={{marginTop: "8%"}}>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "80%", paddingTop: "0.75%"}}>Unlimited customer sign ups</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "80%", paddingTop: "0.75%"}}>Unlimited customer rewards</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "80%", paddingTop: "0.75%"}}>Unlimited feature access</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "80%", paddingTop: "0.75%"}}>White label branding</p>
                                            </div>
                                        </div>
                                        <div className='priceFeatures'>
                                            <div className='priceFeatureCol1'>
                                                <img src='/assets/priceFeatureCheck.png'/>
                                            </div>
                                            <div className='priceFeatureCol2'>
                                                <p style={{fontSize: "80%", paddingTop: "0.75%"}}>Personalized URL for your brand</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{marginTop: "6.5%"}}>
                                        <button
                                        >Get Started</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </CSSTransition>
                </div>
                <div className='footerSmallPhone'>
                    <div className='footerCol1SmallPhone'>
                        <img src="/assets/paper-plane-logo.png"/>
                        <div className='footerSocial'>
                            {/* <img src='/assets/footer-linkedin.png'/> */}
                        </div>
                        {/* <label style={{marginLeft: "1.5%", color: "white", fontFamily: "sora"}}>kifaa</label> */}
                        {/* <p>© kifaa</p> */}
                    </div>
                    <div className='footerCol2SmallPhone'>
                        <h3>Product</h3>
                        <p onClick={this.handleScrollToFeatures}><label>Features</label></p>
                        <p onClick={this.handleScrollToPricing}><label>Pricing</label></p>
                    </div>
                    <div className='footerCol3SmallPhone'>
                        <h3>Contact</h3>  
                        <p><label><a href={`tel:${phoneNumber}`}>{phoneNumber}</a></label></p> 
                    </div>
                    <div className='footerCol4'>
                        {/* <h3>Legal</h3>  
                        <p><label>Terms of use</label></p> 
                        <p><label>Privacy policy</label></p>  */}
                    </div>
                </div>
            </div>
        )
    }

        //* - - OTHER FUNCTIONS - - *//

    handleScrollToFeatures = () => {
        const element = document.getElementById('features');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          if (this.state.isDropdownOpen === true) {
            this.toggleDropdown()
          }
        }
    }

    handleScrollToPricing = () => {
        const element = document.getElementById('pricing');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          if (this.state.isDropdownOpen === true) {
            this.toggleDropdown()
          }
        }
    }

    toggleDropdown = () => {
        this.setState((prevState) => ({
            isDropdownOpen: !prevState.isDropdownOpen,
        }));
    };

    clickedRestaurantGoer = () => {
        window.location.href = '/business/sign-up'
    }

    clickedRestaurantOwner = () => {
        this.setState({
            showLandingPage: false,
            showLoadingScreen: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showLoadingScreen: false,
                    showLandingPage: true
                })
            }, 2500)
        })
    }

    monthlyPriceCardClicked = () => {
        this.setState({
            showMonthlyPriceCard: true,
            showYearlyPriceCard: false,
            monthlyBgColor: "#0930cb",
            monthlyTxtColor: "white",
            yearlyBgColor: "white",
            yearlyTxtColor: "#0930cb"
        })
    }

    yearlyPriceCardClicked = () => {
        this.setState({
            showMonthlyPriceCard: false,
            showYearlyPriceCard: true,
            monthlyBgColor: "white",
            monthlyTxtColor: "#0930cb",
            yearlyBgColor: "#0930cb",
            yearlyTxtColor: "white"
        })
    }

    goToArticle1 = () => {
        // const newWindowUrl = '';
        // window.location.href = newWindowUrl
        window.open('https://hbr.org/1995/05/do-rewards-really-create-loyalty', '_blank')
    }

    goToArticle2 = () => {
        // const newWindowUrl = '';
        // window.location.href = newWindowUrl
        window.open('https://www.researchgate.net/publication/290890144_Do_Customer_Loyalty_Programs_Really_Work', '_blank')
    }

    goToArticle3 = () => {
        // const newWindowUrl = '';
        // window.location.href = newWindowUrl
        window.open('https://blog.hubspot.com/service/customer-loyalty-program', '_blank')
    }

    bookCalendarEvent = () => {
        window.open("https://calendly.com/normanburuchara/30min","_blank")
    }

    render () {

        const computerMediaQuery = `(min-width: 1456px)`
        const computerFinallMediaQuery = `(min-width: 1361px) and (max-width: 1455px)`
        const computerLargestlMediaQuery = `(min-width: 1266px) and (max-width: 1360px)`
        const computerLargeMediaQuery = `(min-width: 1171px) and (max-width: 1265px)`
        const computerLargerMediaQuery = `(min-width: 1076px) and (max-width: 1170px)`
        const largestTabletMediaQuery = `(min-width: 981px) and (max-width: 1075px)`; 
        const largeTabletMediaQuery = `(min-width: 886px) and (max-width: 980px)`; 
        const tabletMediaQuery = `(min-width: 792px) and (max-width: 885px)`; 
        const finalPhabletMediaQuery = `(min-width: 699px) and (max-width: 791px)`
        const largestPhabletMediaQuery = `(min-width: 604px) and (max-width: 698px)`
        const largePhabletMediaQuery = `(min-width: 509px) and (max-width: 603px)`
        const phabletMediaQuery = `(min-width: 414px) and (max-width: 508px)`
        // const standardPhoneQuery = `(min-width: 376px) and (max-width: 414px)`
        const smallPhoneQuery = `(min-width: 320px) and (max-width: 413px)`

        return (
            <Styles>

              

                {/*  - - RENDER LAPTOP/DESKTOP VIEW - - */}

                <MediaQuery query={computerMediaQuery}>
                    {this.renderDesktopView()}
                </MediaQuery>

                {/*  - - RENDER LARGER LAPTOP/DESKTOP VIEW - - */}

                <MediaQuery query={computerLargerMediaQuery}>
                    {this.renderLargerDesktopView()}
                </MediaQuery>

                {/*  - - RENDER LARGE LAPTOP/DESKTOP VIEW - - */}

                <MediaQuery query={computerLargeMediaQuery}>
                    {this.renderLargeDesktopView()}
                </MediaQuery>

                {/*  - - RENDER LARGEST LAPTOP/DESKTOP VIEW - - */}

                <MediaQuery query={computerLargestlMediaQuery}>
                    {this.renderLargestDesktopView()}
                </MediaQuery>

                {/*  - - RENDER FINAL LAPTOP/DESKTOP VIEW - - */}

                <MediaQuery query={computerFinallMediaQuery}>
                    {this.renderFinalDesktopView()}
                </MediaQuery>

                

                {/*  - - RENDER TABLET VIEW - - */}
                
                <MediaQuery query={tabletMediaQuery}>
                    {this.renderTabletView()}
                </MediaQuery>

                {/*  - - RENDER LARGE TABLET VIEW - - */}
                
                <MediaQuery query={largeTabletMediaQuery}>
                    {this.renderLargeTabletView()}
                </MediaQuery>

                {/*  - - RENDER LARGEST TABLET VIEW - - */}
                
                <MediaQuery query={largestTabletMediaQuery}>
                    {this.renderLargestTabletView()}
                </MediaQuery>

                

                {/*  - - RENDER PHABLET VIEW - - */}

                <MediaQuery query={phabletMediaQuery}>
                    {this.renderPhabletView()}
                </MediaQuery>

                {/*  - - RENDER LARGE PHABLET VIEW - - */}

                <MediaQuery query={largePhabletMediaQuery}>
                    {this.renderLargePhabletView()}
                </MediaQuery>

                {/*  - - RENDER LARGEST PHABLET VIEW - - */}

                <MediaQuery query={largestPhabletMediaQuery}>
                    {this.renderLargestPhabletView()}
                </MediaQuery>

                {/*  - - RENDER FINAL PHABLET VIEW - - */}

                <MediaQuery query={finalPhabletMediaQuery}>
                    {this.renderFinalPhabletMediaQuery()}
                </MediaQuery>

                {/*  - - RENDER STANDARD PHONE VIEW - - */}

                {/* <MediaQuery query={standardPhoneQuery}>
                    {this.renderStandardPhoneView()}
                </MediaQuery> */}

           

                {/*  - - RENDER SMALL PHONE VIEW - - */}

                <MediaQuery query={smallPhoneQuery}>
                    {this.renderSmallPhoneView()}
                </MediaQuery>
            </Styles>
        )
    }
}